<template>
  <div class="Investment-box depositbox">
    <ul class="breadcrumbs-list">
      <a  @click="backButton"><li>Investment</li></a>
      <a v-if="subcategoryName" @click="depositeDashbord($route.params.current_category_id)"><li>&nbsp;>&nbsp;{{subcategoryName}} Dashboard</li></a>
      <li>&nbsp;>&nbsp;Dashboard</li>
    </ul>
    <div class="head-text">
      <h1></h1>
    </div>
    <div class="card-box">
        <h4>Select your option  </h4>
        <v-row>
          <template>
            <v-card
              v-for="categoryList in category"
              :key="categoryList.id"
              class="boxs"
              outlined
            >
              <v-list-item three-line @click="childforms(categoryList.child_subcategory_name,categoryList.id)">
                <v-list-item-content>
                  <div class="overline">
                    <v-row>
                      <v-col>
                        <p>{{categoryList.tot_count}}</p>
                      </v-col>
                      <v-col>
                        <v-img max-height="58" max-width="50" :src="webIcon + categoryList.web_icon"></v-img>
                      </v-col>
                    </v-row>
                  </div>
                  <v-list-item-title>{{categoryList.child_subcategory_name}}</v-list-item-title>
                </v-list-item-content>
                <!-- <v-btn @click="subcategory(categoryList)" text> -> </v-btn> -->
              </v-list-item>
            </v-card>
          </template>
        </v-row>
        <div class="text-center ">
          <v-dialog
            v-model="dialog"
            width="800">
            <v-card class="secure-modal proceed-modal">
              <v-card-title class="">
                <h5>Select your option to proceed</h5>
                 <v-card-actions class="close-icon">
                  <v-btn
                    color="primary"
                    text
                    @click="dialog = false"
                  >
                    <v-img max-height="23" max-width="19" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-card-text>
               <div style="margin-top:10px;">
                  <p>Select an option to upload your financial information</p>
                  <div class="button-box" v-if="is_show_upload_block">
                    <div class="coming-soonbox">
                      <!-- <v-btn
                        class="orange-btn"
                        @click="autoTrackStatementBtn(dashboardType)"


                        style="height:99px !important;"

                      >
                        Auto Tack - Sync email to auto update<br>
                        (Currently available with Gmail. <br>Others to be ready soon.)
                      </v-btn> -->

                      <v-btn
                        class="orange-btn"
                       
                    

                        style="height:99px !important;"

                      >
                        Auto Tack - Sync email to auto update<br>
                        (Coming Soon)
                      </v-btn>


                      
                    </div>
                    <div class="coming-soonbox">
                      <v-btn
                        class="orange-btn"
                        @click="uploadAccountBtn"
                        disable
                        style="height:99px !important; min-width:320px !important;"
                      >
                        Upload <br/> Account Statement <br/> ({{account_statement_text}})<br>
                      </v-btn>
                    </div>
                  </div>
                  <div class="button-box">
                  
                    <v-btn
                      class="orange-btn"
                      @click="uploadCSVBtn(manuallyId)"
                        style="height:99px !important; min-width: 320px !important"

                    >
                      Upload data <br/> using CSV file
                    </v-btn>
                    <v-btn
                      class="orange-btn"
                      @click="manuallyBtn(manuallyId)"
                        style="height:99px !important; min-width: 320px !important;"

                    >
                      Add Manually <br/> (Assisted Mode)
                    </v-btn>
                  </div>
                  
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="epf_dialog"
            width="500">
            <v-card class="secure-modal proceed-modal">
              <v-card-title class="">
                <h5>Select your option to proceed</h5>
                 <v-card-actions class="close-icon">
                  <v-btn
                    color="primary"
                    text
                    @click="dialog = false"
                  >
                    <v-img max-height="23" max-width="19" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-card-text>
               <div style="margin-top:10px;">
                  <p>Select an option to upload your financial information</p>
                  <div class="button-box">
                    <v-btn
                      class="orange-btn"
                      @click="manuallyBtn(manuallyId)"
                    >
                      Add Manually <br/> (Assisted Mode)
                    </v-btn>
                    <!-- <v-btn
                      class="orange-btn"
                      @click="uploadAccountBtn"
                    >
                      Update EPF details <br/> using UAN
                    </v-btn> -->
                  </div>
                  <!-- <div class="button-box" v-if="is_show_upload_block">
                    <div class="coming-soonbox">
                      <v-btn
                        class="gray-btn"
                        @click="syncAccountBtn"
                      >
                        Upload <br/> Account Statement <br/> from EPF
                      </v-btn>
                      <span style="color:red">coming soon</span>
                    </div>
                  </div> -->
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>

        <div class="text-center ">
          <v-dialog
            v-model="dialog1"
            width="550">
            <v-card class="secure-modal proceed-modal csv-file-modal">
              <v-card-title class="text-h5  ">
                <h5>Upload Using CSV File in 3 Steps</h5>
                 <v-card-actions class="close-icon">
                  <v-btn
                    color="primary"
                    text
                    @click="dialog1 = false"
                  >
                    <v-img max-height="23" max-width="19" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-card-text>
               <div style="margin-top:10px;">
                <span>Steps to follow</span>
                <ul>
                  <li>Download CSV file on your laptop/desktop</li>
                  <li>Fill in investment details</li>
                  <li>Upload CSV file</li>
                </ul>
                <p style="color:#31465f ; text-align:center;">
                  <b style="font-size:20px;">Note:-</b> 
                </p>
                <p style="color:#31465f ;">1- The dashboard will be updated basis the investment details provided in uploaded CSV file.</p>
                <p style="color:#31465f ;">2- The CSV file has the following fields and please note the instructions while entering the data.</p>
                <p style="color:#31465f ;" v-if="is_saving_instruction==true">
                  <ul>
                    <li>“Account Type” – Enter as “Bank” or “Post Office”.</li>
                    <li>Bank/PO Name – Enter the name of the bank example “HDFK Bank” or post office example “Russa PO”.</li>
                    <li>“Account Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
                    <li>“Joint Account Owner” – Enter Joint Account Owner’s name as specified in your application if required. Example “B Nair”. If Joint Account Owner is not there, please keep it blank.</li>
                    <li>“Account Number” – Enter Account Number.</li>
                    <li>“Current Balance” – Enter balance in your saving account. Mention amount only, don’t mention “Rs”.</li>
                    <li>“Balance Date” – Enter the date for which you have entered the balance amount, Date must be in “YYYY-MM-DD” format.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_fixed_instruction==true">
                  <ul>
                    <li>“Account Type” – Enter as “Bank” or “Post Office”.</li>
                    <li>Bank/PO Name – Enter the name of the bank example “HDFK Bank” or post office example “Russa PO”.</li>
                    <li>“Account Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
                    <li>“Joint Account Owner” – Enter Joint Account Owner’s name as specified in your application if required. Example “B Nair”. If Joint Account Owner is not there, please keep it blank.</li>
                    <li>“Account Number” – Enter Account Number.</li>
                    <li>“Amount Invested” – Enter the fixed deposit investment amount only, don’t mention “Rs”.</li>
                    <li>“Interest Rate” – Enter the interest rate for your fixed deposit. Don’t mention % sign.</li>
                    <li>“Start Date” – Enter the start date for your fixed deposit. Date must be in “YYYY-MM-DD” format.</li>
                    <li>Maturity Date” – Enter the start date for your fixed deposit. Date must be in “YYYY-MM-DD” format.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_recurring_instruction==true">
                  <ul>
                    <li>“Account Type” – Enter as “Bank” or “Post Office” or “Company”.</li>
                    <li>Bank/PO Name – Enter the name of the bank example “HDFK Bank” or post office example “Russa PO”.</li>
                    <li>“Account Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
                    <li>“Joint Account Owner” – Enter Joint Account Owner’s name as specified in your application if required. Example “B Nair”. If Joint Account Owner is not there, please keep it blank.</li>
                    <li>“Account Number” – Enter Account Number.</li>
                    <li>“RD Instalment” – Enter recurring deposit monthly investment amount only, don’t mention “Rs”.</li>
                    <li>“Interest Rate” – Enter the interest rate for your recurring deposit. Don’t mention % sign.</li>
                    <li>“Start Date” – Enter the start date for your recurring deposit. Date must be in “YYYY-MM-DD” format.</li>
                    <li>“Maturity Date” – Enter the maturity date for your recurring deposit. Date must be in “YYYY-MM-DD” format.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_sukanaya_instruction==true">
                  <ul>
                    <li>“Account Type” – Enter as “Sukanya Samriddhi Account”.</li>
                    <li>“Account Owner” – Enter Account Owner’s name as specified in your application. Example “D Nair”.</li>
                    <li>“Depositor Name” – Enter depositor name as specified in your application if required.</li>
                    <li>Bank/PO Name – Enter the name of the bank example “HDFK Bank” or post office example “Russa PO”.</li>
                    <li>“Deposit Number” – Enter Sukanya Samriddhi Account Number.</li>
                    <li>“Start Date” – Enter the start date for your Sukanya Samriddhi Account. Date must be in “YYYY-MM-DD” format.</li>
                    <li>“Maturity Date” – Enter the maturity date for your Sukanya Samriddhi Account. Date must be in “YYYY-MM-DD” format.</li>
                    <li>“Total Investment” - Enter total investment made as on date in your account. Mention amount only, don’t mention “Rs”.</li>
                    <li>“Current Balance” – Enter balance in your Sukanya Samriddhi Account. Mention amount only, don’t mention “Rs”.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_lumpsump_instruction==true">
                  <ul>
                    <li>“Mutual Fund Company” – Enter name of mutual fund company as - example “ICICI Mutual Fund”.</li>
                    <li>“Owner” – Enter Account Owner’s name as specified in your application. Example “D Nair”.</li>
                    <li>“Scheme Type” – Enter scheme type as - example “Large Cap Fund”.</li>
                    <li>“Scheme Name” - Enter name of scheme as - example “ICICI Equity Fund”.</li>
                    <li>“Folio Number” – Enter Folio Number of your Scheme.</li>
                    <li>“Total Investment” - Enter total investment made as on date in your account. Mention amount only, don’t mention “Rs”.</li>
                    <li>“Maturity Date” – Enter the maturity date for your recurring deposit. Date must be in “YYYY-MM-DD” format.</li>
                    <li>“Total Investment” - Enter total investment made as on date in your account. Mention amount only, don’t mention “Rs”.</li>
                    <li>“Balance Units” - Enter total number of units as on date in your folio.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_sip_instruction==true">
                  <ul>
                    <li>“Mutual Fund Company” – Enter name of mutual fund company as - example “ICICI Mutual Fund”.</li>
                    <li>“Owner” – Enter Account Owner’s name as specified in your application. Example “D Nair”.</li>
                    <li>“Scheme Type” – Enter scheme type as - example “Large Cap Fund”.</li>
                    <li>“Scheme Name” - Enter name of scheme as - example “ICICI Equity Fund”.</li>
                    <li>“Folio Number” – Enter Folio Number of your Scheme.</li>
                    <li>“Monthly SIP Amount” - Enter SIP amount only, don’t mention “Rs”.</li>
                    <li>“SIP Start Date” – Enter the start date for your SIP investment. Date must be in “YYYY-MM-DD” format.</li>
                    <li>“SIP End Date” – Enter the maturity date for your SIP investment. Date must be in “YYYY-MM-DD” format.</li>
                    <li>“SIP Frequency Date” – Enter SIP frequency date as “Daily”/”Weekly”/”Monthly”/”Yearly”  – example “Monthly”.</li>
                    <li>“Total Investment” - Enter total investment made as on date in your account. Mention amount only, don’t mention “Rs”.</li>
                    <li>“Balance Units” - Enter total number of units as on date in your folio.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_equity_instruction==true">
                  <ul>
                    <li>“Exchange” – Enter exchange as “NSE” or “BSE” - example “NSE”.</li>
                    <li>“Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
                    <li>“Security Name” - Enter name of share as - example “ICICI Bank”.</li>
                    <li>“No of Shares” - Enter total number of shares as on date.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_etf_instruction==true">
                  <ul>
                    <li>“Exchange” – Enter exchange as “NSE” or “BSE” - example “NSE”.</li>
                    <li>“Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
                    <li>“ETF Name” - Enter name of share as - example “HDFC Nifty”.</li>
                    <li>“No of Units” - Enter total number of units as on date.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_bond_instruction==true">
                  <ul>
                    <li>“Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
                    <li>“Bond Name” - Enter name of bond as - example “L&T Finance”.</li>
                    <li>“Scrip Name” – Enter Scrip Name as - example “925LTFL24”.</li>
                    <li>“No of Bonds” - Enter total number of bonds as on date.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_bar_coins_instruction==true">
                  <ul>
                    <li>“Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
                    <li>“Invoice Number” - Enter bill or invoice number.</li>
                    <li>“Type” – Enter as “Gold Coin”/ ”Gold Bar” /“Silver Coin”/ ”Silver Bar”.</li>
                    <li>“Purity” – Enter purity of Gold or Silver.</li>
                    <li>“Quantity (in gm)” - Enter total quantity held in grams.</li>
                    <li>“Amount Invested” – Enter total investment made as on date. Mention amount only, don’t mention “Rs”.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_jewellery_instruction==true">
                  <ul>
                    <li>“Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
                    <li>“Invoice Number” - Enter bill or invoice number.</li>
                    <li>“Type” – Enter as “Gold Jewellery”/ ”Silver Jewellery”.</li>
                    <li>“Purity” – Enter purity of Gold or Silver.</li>
                    <li>“Quantity (in gm)” - Enter total quantity held in grams.</li>
                    <li>“Amount Invested” – Enter total investment made as on date. Mention amount only, don’t mention “Rs”.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_gold_silver_instruction==true">
                  <ul>
                    <li>“Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
                    <li>“Invoice Number” - Enter bill or invoice number.</li>
                    <li>“Company” – Enter as “MMTC - PAMP”/ ”SAFEGOLD”.</li>
                    <li>“Purity” – Enter purity as ”24K 99.9%”.</li>
                    <li>“Quantity (in gm)” - Enter total quantity held in grams.</li>
                    <li>“Amount Invested” – Enter total investment made as on date. Mention amount only, don’t mention “Rs”.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;" v-if="is_gold_bond_instruction==true">
                  <ul>
                    <li>“Exchange” – Enter exchange as “NSE” or “BSE” - example “NSE”.</li>
                    <li>“Gold Bond Name” – Enter bond name.</li>
                    <li>“Owner” – Enter Account Owner’s name as specified in your application. Example “A Nair”.</li>
                    <li>“Units” - Enter total units of bonds.</li>
                    <li>“Amount Invested” – Enter total investment made as on date. Mention amount only, don’t mention “Rs”.</li>
                    <li>“Nominee” – Enter name of your nominee/s.</li>
                  </ul>
                </p>
                <p style="color:#31465f ;">3- Please don’t add any additional field.</p>
                <p style="color:#31465f ;">4- Please don’t change header.</p>
                <p style="color:#31465f ;">5- View sample CSV file if you need any clarification.</p>
                <p style="color:#31465f ;">6- Once you upload a CSV file a table will be generated with all date provided.</p>
                <p style="color:#31465f ;">7- Please validate data which are marked as red and confirm.</p>
                <p style="color:#31465f ;">8- Once confirmed you can view the dashboard.</p>
                <p style="color:#31465f ;"  v-if="is_saving_instruction==true">
                  9- You can subsequently modify your savings account balance using “Edit” option from your dashboard.
                </p>
                <p style="color:#31465f ;"  v-if="is_fixed_instruction==true">
                  9- Your fixed deposit balance will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_recurring_instruction==true">
                  9- Your recurring deposit balance will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_sukanaya_instruction==true">
                  9- You can subsequently modify your Sukanya Samriddhi Account balance using “Edit” option from your dashboard.
                </p>
                <p style="color:#31465f ;"  v-if="is_lumpsump_instruction==true">
                  9- Your scheme account balance will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_sip_instruction==true">
                  9- Your scheme account balance will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_sip_instruction==true">
                  10- You can subsequently modify number of units in your scheme using “Edit” option from your dashboard.
                </p>
                <p style="color:#31465f ;"  v-if="is_equity_instruction==true">
                  9- Your share valuation will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_equity_instruction==true">
                  10- You can subsequently modify number of shares using “Edit” option from your dashboard.
                </p>
                <p style="color:#31465f ;"  v-if="is_etf_instruction==true">
                  9- Your ETF valuation will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_etf_instruction==true">
                  10- You can subsequently modify number of units using “Edit” option from your dashboard.
                </p>
                <p style="color:#31465f ;"  v-if="is_bond_instruction==true">
                  9- Your Bond valuation will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_bond_instruction==true">
                  10- You can subsequently modify number of bonds using “Edit” option from your dashboard.
                </p>
                <p style="color:#31465f ;"  v-if="is_bar_coins_instruction==true">
                  9- Your Bar & Coins valuation will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_bar_coins_instruction==true">
                  10- You can subsequently modify quantity using “Edit” option from your dashboard.
                </p>
                <p style="color:#31465f ;"  v-if="is_bar_coins_instruction==true">
                  9- Your Bar & Coins valuation will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_bar_coins_instruction==true">
                  10- You can subsequently modify quantity using “Edit” option from your dashboard.
                </p>
                <p style="color:#31465f ;"  v-if="is_jewellery_instruction==true">
                  9- Your Jewellery valuation will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_jewellery_instruction==true">
                  10- You can subsequently modify quantity using “Edit” option from your dashboard.
                </p>
                <p style="color:#31465f ;"  v-if="is_gold_silver_instruction==true">
                  9- Your Digital Gold valuation will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_gold_silver_instruction==true">
                  10- You can subsequently modify quantity using “Edit” option from your dashboard.
                </p>
                <p style="color:#31465f ;"  v-if="is_gold_bond_instruction==true">
                  9- Your Gold Bond valuation will be updated daily.
                </p>
                <p style="color:#31465f ;"  v-if="is_gold_bond_instruction==true">
                  10- You can subsequently modify units using “Edit” option from your dashboard.
                </p>

                <div class="button-box">
                   <v-btn
                    class="orange-btn"
                    @click="downloadCSVBtn(manuallyId)"
                  >
                    <p>View</p>
                    <p>Sample CSV file</p>
                  </v-btn>
                  <v-btn
                    class="orange-btn"
                    @click="downloadSampleCSVBtn(manuallyId)"
                  >
                     <p>Download</p>
                     <p>CSV file</p>
                  </v-btn>
                  <v-btn
                    class="orange-btn"
                    @click="uploadCSVFileBtn(manuallyId)"
                  >
                    <p>Upload</p>
                    <p>CSV file</p>
                  </v-btn>
                  </div>
              <!--   <v-btn
                  class="blue-btn"
                  @click="submit"
                >
                  Continue 
                </v-btn> -->
              </div>
              </v-card-text>
             
            </v-card>
          </v-dialog>
        
          <!-- Upload NSDL/CDSL Statement form -->
          <v-dialog v-model="upload_cdsl_nsdl_form_dialog" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="text-h5" v-if="account_statement_text=='NSDL/CDSL'">Upload NSDL/CDSL Doc</span>
                <span class="text-h5" v-else>Upload Kfintech/Protean CRA Doc</span>
              </v-card-title>
              <form ref="form" id="upload_cdsl_nsdl_form"  @submit.prevent lazy-validation>
                <v-card-text >
                  <v-container>
                    <v-row >
                      <v-col cols="12" sm="12" md="12" v-if="account_statement_text=='NSDL/CDSL'">
                        <label>Choose Account Statement Type</label>
                        <v-select
                          ref="account_statement_type"
                          name="account_statement_type" 
                          v-model="account_statement_type"
                          :items="account_statement_type_itmes"
                          item-value="id"
                          item-text="name"
                          placeholder="Select Statement Type"
                           @change="removeError($event)"
                        ></v-select>
                        <p style="color:red;">{{account_type_error_text}}</p>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-else>
                        <label>Choose NPS Account Statement Type</label>
                        <v-select
                          ref="account_statement_type"
                          name="account_statement_type" 
                          v-model="account_statement_type"
                          :items="nps_account_statement_type_itmes"
                          item-value="id"
                          item-text="name"
                          placeholder="Select Statement Type"
                           @change="removeError($event)"
                        ></v-select>
                        <p style="color:red;">{{account_type_error_text}}</p>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <label>Choose Member</label>
                        <v-select
                          ref="family_member_name"
                          name="family_member_name"
                          v-model="family_member_name" 
                          :items="family_member_list"
                          item-value="id"
                          item-text="name"
                          placeholder="Select Family Member"
                          @change="trackPanNo($event)"
                        ></v-select>
                        <p style="color:red;">{{family_member_error_text}}</p>
                      </v-col>  
                      <v-col cols="12" sm="12" md="12" class="relative col passwordbox">
                        <label>{{upload_statement_password_text}}</label>
                        <v-text-field
                          class="relative"
                          :type="show_password ? 'text' : 'password'"
                          name="password"
                          v-model="password"
                          ref="password" 
                          id = "password"
                          :placeholder="upload_statement_password_text"
                          :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="show_password = !show_password"
                          ></v-text-field>
                          <p style="color:red;">{{pan_error_text}}</p>
                      </v-col> 
                      
                      <v-col cols="12" sm="12" md="12">  
                        <label>Choose File</label>  
                        <v-file-input
                          name="account_statement_file_upload"
                          id="account_statement_file_upload"
                          ref="file"
                          @change="handleAccountStatementFileUpload( $event )"
                          label="Choose Doc"
                          accept=".pdf"
                        ></v-file-input>
                        <p style="color:red;">{{doc_error_text}}</p>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">  
                        <form class="login-form-box register-page pricing-plan_modal-bottombox" style="margin-left:-54px !important;">
                          <v-row class="register-checkbox">
                            <v-checkbox
                              id="checkboxfield"
                              required
                              color="orange"
                              checked="checked"
                              ref="checkboxfield"
                              v-model="checkboxfield"
                              @click="agree($event)"

                            ></v-checkbox>
                              I agree to Account Statement Upload&nbsp;<a href="javascript:void(0)" style="text-decoration: none;" @click="statementUploadTermCondition()">terms & conditions</a>
                          </v-row>
                          <p  style="color:red !important;" >{{is_agree_active_error}}</p>
                        </form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions >
                  <v-spacer></v-spacer>
                  <v-btn
                    class="blue-border-btn"
                    text
                    @click="closeAccountStatementFileUpload"  
                  >
                    Close
                  </v-btn>
                  <v-btn
                    style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;"
                    text
                    @click="submitNsdlCdslStatement"  
                  >
                    Upload
                  </v-btn>
                </v-card-actions>
              </form>  
            </v-card>
          </v-dialog> 
          <!-- End of upload NSDL/CDSL Statement form -->

          <!-- EPF UAN Form -->
          <v-dialog v-model="epf_uan_form_dialog" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="text-h5" v-if="account_statement_text=='NSDL/CDSL'">Employee's Provident Fund</span>
              </v-card-title>
              <span class="text-4">Update EPF details</span>
              <form ref="form" id="upload_cdsl_nsdl_form" @submit.prevent lazy-validation>
                <v-card-text >
                  <v-container>
                    <v-row >
                      <v-col cols="12" sm="12" md="12">
                        <label>MEMBER NAME</label>
                        <v-select
                          ref="epfo_member"
                          name="epfo_member"
                          v-model="epfo_member" 
                          :items="member_list_new"
                          item-value="id"
                          item-text="name"
                          placeholder="Select Member"
                          @change="removeEpfoError($event)"
                        ></v-select>
                        <p style="color:red;">{{epfo_member_error_text}}</p>
                      </v-col>  
                      <v-col cols="12" sm="12" md="12">
                        <label>UAN NUMBER</label>
                        <v-text-field
                          name="uan_number"
                          v-model="uan_number"
                          ref="uan_number" 
                          id = "uan_number"
                          placeholder="Enter UAN Number"
                          @keyup="removeEpfoError($event)"
                        ></v-text-field>
                        <p style="color:red;">{{uan_error_text}}</p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions >
                  <v-spacer></v-spacer>
                  <v-btn
                    class="blue-border-btn"
                    text
                    @click="closeEpfUanFormDialog"  
                  >
                    Close
                  </v-btn>
                  <v-btn
                    style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;"
                    text
                    @click="submitEpfUanForm"  
                  >
                    Proceed
                  </v-btn>
                </v-card-actions>
              </form>  
            </v-card>
          </v-dialog> 
          <!-- End of EPF UAN Form -->
                    <!-- start otp page -->
           <v-dialog  v-model="otp_uan_form_dialog" persistent max-width="500px">
            <v-card class="otp-modalbox">
                <span class="otp-text">OTP Varification</span>
                 <span> 
              <img width="30" height="30" @click="closeOtpDialog" style="float: right; padding:6px;" :src="cross_img"/>
              </span>
             <form
                ref="form"
                @submit.prevent
              >
                <v-card-text >
                  <v-container class="form-page-otp">
                    <p>You will receive the OTP on the following number ending with xxxxxx{{uan_last_four}}</p>
                    <br>
                    <span>ENTER VERIFICATION CODE</span>
                     <v-text-field
                      class=""
                      v-model="verify_otp"
                      name="verify_otp"
                      id="verify_otp"
                      placeholder="Enter OTP"
                      @keyup="removeEpfoError($event)"
                    ></v-text-field>
                    <p style="color:red;">{{verify_otp_error_text}}</p>
                  </v-container>
                  <p style="margin-left:16px">In case you have not received the OTP in the next 5 min please press the “Resend” button below.</p>
                </v-card-text>
                  <div class="button-box">
                  <v-btn class="btn-otp" @click="verifyOtp">
                    Confirm
                  </v-btn>
                 <v-btn @click="submitEpfUanForm" class="sign-up-btn"> Resend OTP </v-btn>
              </div> 
              </form>
          
            </v-card>
          </v-dialog>
          <!-- End otp page -->

          <!-- Upload CSV form -->
          <v-dialog v-model="csv_dialog" persistent max-width="600px">
            <v-card>
              <v-card-title>
                <span class="text-h5">Upload Doc</span>
              </v-card-title>
              <form
                ref="form"
                id="upload_deposit_keep_safe_form"
                @submit.prevent
                lazy-validation
              >
                <v-card-text >
                  <v-container>
                    <v-row >
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                      <v-file-input
                        name="file"
                        id="fileUpload"
                        ref="file"
                        @change="handleFileUpload( $event )"
                        label="Choose Doc"
                        accept=".csv"
                        :key="componentKey"
                      ></v-file-input>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions >
                  <v-spacer></v-spacer>
                  <v-btn
                    class="blue-border-btn"
                    text
                    @click="closeCsvDialog"  
                  >
                    Close
                  </v-btn>
                  <v-btn
                    style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;"
                    text
                    @click="submit"  
                  >
                    Upload
                  </v-btn>
                </v-card-actions>
              </form>  
            </v-card>
          </v-dialog>
          <!-- End of Upload CSV form --> 
          <v-dialog v-model="preview_dialog" persistent max-width="1100px">
            <v-card-title class="equity-modal-imgbox">
              <v-card-actions class="close-icon">
                  <v-btn
                    color="primary"
                    text
                    @click="preview_dialog = false"
                  >
                    <v-img max-height="28" max-width="28" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
                  </v-btn>
              </v-card-actions>
              <v-col class="image-box">
                <v-img
                  :src="previewImage"
                  :lazy-src="previewImage"
                >
                </v-img>
            </v-col>
            </v-card-title>
          </v-dialog>

          <v-dialog v-model="nsdl_cdsl_upload_info_dialog" width="550">
            <v-card class="secure-modal proceed-modal csv-file-modal">
              <v-card-title class="text-h5"  v-if="account_statement_text=='NSDL/CDSL'">
                <h5>Upload Account Statement(NSDL/CDSL)</h5>
              </v-card-title>
              <v-card-title class="text-h5"  v-else>
                <h5>Upload NPS Account Statement (Kfintech/Protean CRA)</h5>
              </v-card-title>

              <v-card-text v-if="account_statement_text=='NSDL/CDSL'">
                <div style="margin-top:10px;">
                  <p>We will need PAN to read your statement. Please update PAN for yourself and other members in the profile section. For security purpose we will mask PAN. You will need an OTP to view the same.Once you upload using CDSL/NSDL statement your data will be updated in the following sections – Mutual Fund, Equities & Bonds, Gold Bonds, REIT & InvIT as applicable.</p>
                  <p>Once you upload using CDSL/NSDL statement your data will be updated in the following sections – Mutual Fund, Equities & Bonds, Gold Bonds, REIT & InvIT as applicable.</p>
                </div>  
              </v-card-text>
              <v-card-text v-else>
                <div style="margin-top:10px;">
                  <p>We will need the PRAN number of the member (if you are uploading statement from KFintech) or 8-characters password (if you are uploading statement from Protean (NSDL) – CRA.</p>
                  <p>The 8 characters password will be as per instruction given below:</p>
                  <p>1. First four characters - The first four letter of your "First Name" in lower case. In case your "First Name" is less than four letter, please add 9 before entering your "First Name" to make it four characters.</p>
                  <p>2. Last four characters – The data and month of member’s “Date of Birth” as per CRA records in DDMM format.</p>
                </div>  
              </v-card-text>
              <div class="button-box">
                  <v-btn class="orange-btn" @click="nsdlCdslUploadInfoProceed()">
                    Cancel
                  </v-btn>
                  <v-btn class="orange-btn" @click="proceedToNsdlCdslForm()">
                    Proceed
                  </v-btn>
              </div>  
            </v-card>
          </v-dialog>

          <v-dialog v-model="epf_uan_info_dialog" width="550">
            <v-card class="secure-modal proceed-modal csv-file-modal">
              <v-card-title class="text-h5">
                <h5>Employees' Provident Fund</h5>
              </v-card-title>
              How to update EPF details?
              <v-card-text v-if="account_statement_text=='NSDL/CDSL'">
                <div style="margin-top:10px;">
                  <p>Mention the UAN for yourself or any of the members for whom you want to update EPF details.</p>
                  <p>You will receive an OTP on your/member’s registered mobile number. Once you validate with the OTP, the EPF details will be updated.</p>
                  <p>We suggest you to update EPF details for yourself and your members once every month.</p>
                </div>  
              </v-card-text>
              <div class="button-box">
                  <v-btn class="orange-btn" @click="CancelEpfInfoDialog()">
                    Cancel
                  </v-btn>
                  <v-btn class="orange-btn" @click="proceedToEpfUanForm()">
                    Proceed
                  </v-btn>
              </div>  
            </v-card>
          </v-dialog>

          <v-dialog v-model="accept_statement_term_condition_dialogbox" width="900">
            <v-card class="term-modal">
              <v-card-title class="text-h5" v-if="account_statement_text=='NSDL/CDSL'">
                NSDL/CDSL Account statement upload- Terms & Conditions
                <v-card-actions class="close-icon">
                  <v-btn color="primary" text @click="dialog1 = false">
                    <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-card-title class="text-h5" v-else>
                NPS Account statement upload- Terms & Conditions
                <v-card-actions class="close-icon">
                  <v-btn color="primary" text @click="dialog1 = false">
                    <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-card-text v-if="account_statement_text=='NSDL/CDSL'">
                <p>1- You can use PDF upload statement to update data for the following modules</p>
                <p>
                  <ul>
                    <li>Mutual Fund</li>
                    <li>Equities & Bonds</li>
                    <li>Gold Bond</li>
                    <li>REIT</li>
                    <li>InvIT</li>
                  </ul>
                </p>
                <p>
                  2- By agreeing you will allow Nimeya to access the following details from your CDSL/NSDL statement
                </p>
                <p>
                  <ul>
                    <li>Date</li>
                    <li>Name</li>
                    <li>ISIN</li>
                    <li>Security Name</li>
                    <li>Quantity/units</li>
                    <li>Investment</li>
                    <li>And other relevant details as required to update your records</li>
                  </ul>
                </p>
                <p>
                  3- We will require the PAN of the member whose statement has been uploaded
                </p>
                <p>
                  4- If PAN is not up-dated we would request to update PAN of members in profile section
                </p> 
                <p>
                  5- For security reason all PAN will be masked and you will need an OTP to view the same
                </p>
                <p>
                  6- Once you upload the PDF statement for a member, the data will be uploaded in relevant modules
                </p>
                <p>
                  7- You have to upload statement separately for each member
                </p>
                <p>
                  8- You can modify your data subsequently using the EDIT function
                </p>
                <p>
                  9- We will not able to upload data for securities where ISIN numbers are not available
                </p> 
                <p>
                  10- Please add data manually or by uploading CSV file where ISIN numbers are not available
                </p> 
                <p>
                  11- We will not be held responsible for the accuracy of your data
                </p>   
                <form class="login-form-box register-page pricing-plan_modal-bottombox">
                  <v-row>
                    <v-col>
                      <v-btn class="blue-btn"
                        @click="closeAccountStatementTermCondition()">
                        OK   
                      </v-btn>
                    </v-col>
                  </v-row>
                </form>
              </v-card-text>
              <v-card-text v-else>
                <p>1. You can use PDF upload statement to update data related to National Pension Scheme for yourself and other family members</p>
                <p>2. By agreeing you will allow Nimeya to access the following details from your KFintech/Protean (NSDL) CRA statements
                  <p>
                    <ul>
                      <li>Date</li>
                      <li>Name</li>
                      <li>PRAN</li>
                      <li>Total Contribution</li>
                      <li>Total Value</li>
                      <li>Fund Type</li>
                      <li>NPS Fund Manager</li>
                      <li>And other relevant details as required to update your records</li>
                    </ul>
                  </p>
                </p>
                <p>3. We will require the PRAN of the member if the upload statement is from KFintech</p>
                <p>4. We will require the 8 characters password of the member if the upload statement is from Protean (NSDL) CRA</p>
                <p>5. Once you upload the PDF statement for a member, the data can be viewed in the dashboard</p>
                <p>6. You have to upload statement separately for each member</p>
                <p>7. You can modify your data subsequently using the EDIT function</p>
                <p>8. We will not be held responsible for the accuracy of your data</p>               
                <form class="login-form-box register-page pricing-plan_modal-bottombox">
                  <v-row>
                    <v-col>
                      <v-btn class="blue-btn"
                        @click="closeAccountStatementTermCondition()" style="text-align: center;">
                        OK   
                      </v-btn>
                    </v-col>
                  </v-row>
                </form>
              </v-card-text>
            </v-card>
          </v-dialog>


          <v-dialog v-model="capture_auto_sync_email_id" width="550" persistent>
            <v-card class="secure-modal proceed-modal csv-file-modal">
                <v-card-title style="width:926px !important;">
                  <v-card-title class="text-h5">
                    <v-card-actions class="close-icon">
              <v-btn color="primary" text @click="closeAutoSyncDialogCapturedEmail()">
                 <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                 </v-btn>
               </v-card-actions>
                  </v-card-title>  
                </v-card-title>
              <form ref="form" id="auto_sync_form" @submit.prevent lazy-validation>
                <v-card-text >
                  <v-container>
                    <v-row >
                      <v-col cols="12" sm="12" md="12">
                          <v-text-field
                              name="user_auto_sync_email_id"
                              v-model="user_auto_sync_email_id"
                              ref="user_auto_sync_email_id" 
                              id = "user_auto_sync_email_id"
                              placeholder="Enter Auto Sync Email ID"
                          ></v-text-field>
                          <p style="color:red;">{{auto_sync_email_id_error}}</p>
                      </v-col>  
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions >
                  <v-spacer></v-spacer>
                  <v-btn
                    class="blue-border-btn"
                    text
                    @click="closeAutoSyncDialogCapturedEmail()"  
                  >
                    Close
                  </v-btn>
                  <v-btn
                    style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;"
                    text
                    @click="submitAutoSyncDialogFifth()"  
                  >
                    Proceed
                  </v-btn>
                </v-card-actions>
              </form>  
          </v-card>

          <v-dialog v-model="is_auto_sync_dialog_sixth_open" width="550" persistent>
            <v-card class="secure-modal proceed-modal csv-file-modal">
              <v-card-title class="text-h5  ">
                <v-card-actions class="close-icon">
                  <v-btn color="primary" text @click="closeDialogSixth()">
                     <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                     </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-card-text>
                <p>Nimeya.ai wants to use <b style="color:blue">{{this.user_auto_sync_email_id}}</b> to sign in. This allows the app and website to share information about you.</p>
                <form class="login-form-box register-page pricing-plan_modal-bottombox">            
                  <v-row>
                    <v-col>
                      <v-btn class="blue-btn"
                        @click="proceedAutoTrackDialogSeventh">
                        Proceed   
                      </v-btn>
                    </v-col>
                  </v-row>
                </form>
              </v-card-text>
            </v-card>
          </v-dialog>


          <v-dialog v-model="is_auto_sync_dialog_seventh_open" width="1000px" persistent>
            <v-card class="secure-modal proceed-modal csv-file-modal">
              <v-container fluid>

                <v-row dense>
              <v-col width="80px" style="text-align:center">
              <span style="font-size:20px; font-weigth:20px;"><b>Activating<br>Auto Track</b></span>
              <br><br><br><br>
            </v-col>
             
            </v-row>
        

             <v-row dense>
              <v-col width="80px">
                <div class="row">
                  <v-img :src="activating_auto_track_icon" class="align-end" height="200px"></v-img>
                </div>
                <div class="row">
                  <v-img :src="loading_gif" class="align-end" height="200px"></v-img>

                </div>  
              </v-col>
            </v-row>
           
          </v-container>
            </v-card>
          </v-dialog>





  </v-dialog>
        </div>
      <!-- Deposit modules child components -->
        <uploaded_saving_data_list_component  v-bind:modal_saving_open_status="is_saving_modal_open" v-bind:get_uploaded_saving_list="uploaded_saving_list" @getSavingsEditFormData="setSavingEditFormData($event)"/>
        <saving_edit_form_component v-if="is_saving_edit_modal_open"  :saving_edit_form_dialog_status="is_saving_edit_modal_open" v-bind:get_saving_edit_form_data="savings_edit_form_data"  @getSavingUpdatedFormData="setSavingUpdatedFormData($event)" v-bind:get_member_list="member_list"/>

        <uploaded_fixed_data_list_component  v-bind:modal_fixed_deposit_open_status="is_fixed_deposit_modal_open" v-bind:get_uploaded_fixed_deposit_list="uploaded_fixed_deposit_list" @getFixedDepositEditFormData="setFixedDepositEditFormData($event)"/>
        <fixed_edit_form_component v-if="is_fixed_deposit_edit_modal_open"  :fixed_deposit_edit_form_dialog_status="is_fixed_deposit_edit_modal_open" v-bind:get_fixed_deposit_edit_form_data="fixed_deposit_edit_form_data"  v-bind:get_member_list="member_list" @getFixedDepositUpdatedFormData="setFixedDepositUpdatedFormData($event)" />

        <uploaded_recurring_data_list_component  v-bind:modal_recurring_deposit_open_status="is_recurring_deposit_modal_open" v-bind:get_uploaded_recurring_deposit_list="uploaded_recurring_deposit_list" @getRecurringDepositEditFormData="setRecurringDepositEditFormData($event)"/>
        <recurring_edit_form_component v-if="is_recurring_deposit_edit_modal_open"  :recurring_deposit_edit_form_dialog_status="is_recurring_deposit_edit_modal_open" v-bind:get_recurring_deposit_edit_form_data="recurring_deposit_edit_form_data"  v-bind:get_member_list="member_list" @getRecurringDepositUpdatedFormData="setRecurringDepositUpdatedFormData($event)" />

        <uploaded_sukanya_data_list_component  v-bind:modal_sukanya_samridhi_open_status="is_sukanya_samridhi_modal_open" v-bind:get_uploaded_sukanya_samridhi_list="uploaded_sukanya_samridhi_list" @getSukanyaSamridhiEditFormData="setSukanyaSamridhiEditFormData($event)"/>
        <sukanya_edit_form_component v-if="is_sukanya_samridhi_edit_modal_open"  :sukanya_samridhi_edit_form_dialog_status="is_sukanya_samridhi_edit_modal_open" v-bind:get_sukanya_samridhi_edit_form_data="sukanya_samridhi_edit_form_data"  v-bind:get_member_list="member_list" @getSukanyaSamridhiUpdatedFormData="setSukanyaSamridhiUpdatedFormData($event)" />
      <!-- End of deposit modules child components -->

      <!---------------Mutual fund child component------------------------------------------------------>
        <uploaded_lumpsum_data_list_component  v-bind:modal_lumpsum_investment_open_status="is_lumpsum_investment_modal_open" v-bind:get_uploaded_lumpsum_investment_list="uploaded_lumpsum_investment_list" @getLumpsumInvestmentEditFormData="setLumpsumInvestmentEditFormData($event)"/>
        <lumpsum_investment_edit_form_component v-if="is_lumpsum_investment_edit_modal_open"  :lumpsum_investment_edit_form_dialog_status="is_lumpsum_investment_edit_modal_open" v-bind:get_lumpsum_investment_edit_form_data="lumpsum_investment_edit_form_data"  v-bind:get_member_list="member_list" @getLumpsumInvestmentUpdatedFormData="setLumpsumInvestmentUpdatedFormData($event)" />

        <uploaded_sip_data_list_component  v-bind:modal_sip_investment_open_status="is_sip_investment_modal_open" v-bind:get_uploaded_sip_investment_list="uploaded_sip_investment_list" @getSipInvestmentEditFormData="setSipInvestmentEditFormData($event)"/>
        <sip_investment_edit_form_component v-if="is_sip_investment_edit_modal_open"  :sip_investment_edit_form_dialog_status="is_sip_investment_edit_modal_open" v-bind:get_sip_investment_edit_form_data="sip_investment_edit_form_data"  v-bind:get_member_list="member_list" @getSipInvestmentUpdatedFormData="setSipInvestmentUpdatedFormData($event)" />
      <!---------------End of Mutual fund child component------------------------------------------------>


      <!---------------Equity child component------------------------------------------------------>
        <uploaded_equity_data_list_component  v-bind:modal_equity_open_status="is_modal_open" v-bind:get_uploaded_equity_list="uploaded_equity_list" @getEquityEditFormData="setEquityEditFormData($event)"/>
        <equity_edit_form_component v-if="is_equity_edit_modal_open"  :equity_edit_form_dialog_status="is_equity_edit_modal_open" v-bind:get_equity_edit_form_data="equity_edit_form_data" v-bind:get_security_list="security_list" v-bind:get_member_list="member_list" @getEquityUpdatedFormData="setEquityUpdatedFormData($event)" />
      <!---------------End of Equity child component------------------------------------------------>

      <!---------------Bullions child component------------------------------------------------------>
        <uploaded_bar_coins_data_list_component  v-bind:modal_bar_coins_open_status="is_bar_coins_modal_open" v-bind:get_uploaded_bar_coins_list="uploaded_bar_coins_list" @getBarCoinsEditFormData="setBarCoinsEditFormData($event)"/>
        <bar_coins_edit_form_component v-if="is_bar_coins_edit_modal_open"  :bar_coins_edit_form_dialog_status="is_bar_coins_edit_modal_open" v-bind:get_bar_coins_edit_form_data="bar_coins_edit_form_data"  v-bind:get_member_list="member_list" @getBarCoinsUpdatedFormData="setBarCoinsUpdatedFormData($event)" />

        <uploaded_jewellery_data_list_component  v-bind:modal_jewellery_open_status="is_jewellery_modal_open" v-bind:get_uploaded_jewellery_list="uploaded_jewellery_list" @getJewelleryEditFormData="setJewelleryEditFormData($event)"/>
        <jewellery_edit_form_component v-if="is_jewellery_edit_modal_open"  :jewellery_edit_form_dialog_status="is_jewellery_edit_modal_open" v-bind:get_jewellery_edit_form_data="jewellery_edit_form_data"  v-bind:get_member_list="member_list" @getJewelleryUpdatedFormData="setJewelleryUpdatedFormData($event)" />

        <uploaded_digital_silver_gold_data_list_component  v-bind:modal_digital_silver_gold_open_status="is_digital_silver_gold_modal_open" v-bind:get_uploaded_digital_silver_gold_list="uploaded_digital_silver_gold_list" @getDigitalSilverGdEditFormData="setDigitalSilverGoldEditFormData($event)"/>
        <digital_silver_gold_edit_form_component v-if="is_digital_silver_gold_edit_modal_open"  :digital_silver_gold_edit_form_dialog_status="is_digital_silver_gold_edit_modal_open" v-bind:get_digital_silver_gold_edit_form_data="digital_silver_gold_edit_form_data"  v-bind:get_member_list="member_list" @getDigitalSilverGoldUpdatedFormData="setDigitalSilverGoldUpdatedFormData($event)" />

        <uploaded_bullion_gold_bond_data_list_component  v-bind:modal_bullion_gold_bond_open_status="is_bullion_gold_bond_modal_open" v-bind:get_uploaded_bullion_gold_bond_list="uploaded_bullion_gold_bond_list" @getBullionGoldBondEditFormData="setBullionGoldBondEditFormData($event)"/>
        <bullion_gold_bond_edit_form_component v-if="is_bullion_gold_bond_edit_modal_open"  :bullion_gold_bond_edit_form_dialog_status="is_bullion_gold_bond_edit_modal_open" v-bind:get_bullion_gold_bond_edit_form_data="bullion_gold_bond_edit_form_data"  v-bind:get_member_list="member_list" @getBullionGoldBondUpdatedFormData="setBullionGoldBondUpdatedFormData($event)" />
      <!---------------End ofBullions child component------------------------------------------------>

      <!---------------ETF child component------------------------------------------------------>
        <uploaded_etf_data_list_component 
        v-bind:modal_etf_open_status="is_etf_modal_open" 
        v-bind:get_uploaded_etf_list="uploaded_etf_list"
        @getETFEditFormData="setETFEditFormData($event)"
        />

        <etf_edit_form_component 
        v-bind:get_uploaded_etf_master_data_list="uploaded_etf_master_data_list" 
        v-if="is_etf_edit_modal_open" 
        v-bind:etf_edit_form_dialog_status="is_etf_edit_modal_open" 
        v-bind:get_etf_edit_form_data="etf_edit_form_data"  
        @getETFUpdatedFormData="setETFUpdatedFormData($event)" />
      <!---------------End of ETF child component------------------------------------------------>


      <!---------------Equity Bond child component------------------------------------------------------>
        <uploaded_equity_bond_data_list_component 
        v-bind:modal_equity_bond_open_status="is_equity_bond_modal_open" 
        v-bind:get_uploaded_equity_bond_list="uploaded_equity_bond_list"
        @getEquityBondEditFormData="setEquityBondEditFormData($event)"
        />

        <equity_bond_edit_form_component 
        v-if="is_equity_bond_edit_modal_open" 
        v-bind:equity_bond_edit_form_dialog_status="is_equity_bond_edit_modal_open" 
        v-bind:get_equity_bond_edit_form_data="equity_bond_edit_form_data"  
        @getEquityBondUpdatedFormData="setEquityBondUpdatedFormData($event)" />
      <!---------------End of Equity Bond child component------------------------------------------------>


      <!-----------------------------Sync auto statement compoment------------------>
      <auto_sync_dialog_first  v-if="is_auto_sync_dialog_first_open"  v-bind:is_auto_sync_dialog_first_open_status="is_auto_sync_dialog_first_open" v-bind:getDashboardType="dashboardType" v-bind:get_auto_sync_dialog_first_data="auto_sync_dialog_first_data" @allowAutoSyncDialogTwo="openAutoSyncDialogTwo($event)"/>

      <auto_sync_dialog_two  v-if="is_auto_sync_dialog_two_open"  v-bind:is_auto_sync_dialog_two_open_status="is_auto_sync_dialog_two_open" v-bind:getDashboardType="dashboardType" v-bind:get_auto_sync_dialog_two_data="auto_sync_dialog_two_data" @allowAutoSyncDialogThree="openAutoSyncDialogThree($event)"/>

      <auto_sync_dialog_three  v-if="is_auto_sync_dialog_three_open"  v-bind:is_auto_sync_dialog_three_open_status="is_auto_sync_dialog_three_open" v-bind:get_auto_sync_dialog_three_data="auto_sync_dialog_three_data" @allowAutoSyncDialogFourth="openAutoSyncDialogFourth($event)"/>

      <auto_sync_dialog_fourth  v-if="is_auto_sync_dialog_fourth_open"  v-bind:is_auto_sync_dialog_fourth_open_status="is_auto_sync_dialog_fourth_open" v-bind:getDashboardType="dashboardType" v-bind:get_auto_sync_dialog_fourth_data="auto_sync_dialog_fourth_data" @allowAutoSyncDialogFifth="openAutoSyncDialogFifth($event)"/>
      <!---------End Of Sync auto statement------------------------------------------>
    </div>
  </div> 
</template>

<script>

  import uploaded_saving_data_list_component from './segments/uploaded_saving_list';
  import saving_edit_form_component from './segments/uploaded_saving_edit_form';

  import uploaded_fixed_data_list_component from './segments/uploaded_fixed_deposit_list';
  import fixed_edit_form_component from './segments/uploaded_fixed_deposit_edit_form';

  import uploaded_recurring_data_list_component from './segments/uploaded_recurring_deposit_list';
  import recurring_edit_form_component from './segments/uploaded_recurring_deposit_edit_form';

  import uploaded_sukanya_data_list_component from './segments/uploaded_sukanya_samridhi_list';
  import sukanya_edit_form_component from './segments/uploaded_sukanya_samridhi_edit_form';

  import uploaded_lumpsum_data_list_component from './segments/uploaded_lumpsum_investment_data_list';
  import lumpsum_investment_edit_form_component from './segments/lumpsum_investment_edit_form';

  import uploaded_sip_data_list_component from './segments/uploaded_sip_investment_data_list';
  import sip_investment_edit_form_component from './segments/sip_investment_edit_form';

  import uploaded_equity_data_list_component from './segments/uploaded_equity_list';
  import equity_edit_form_component from './segments/uploaded_equity_edit_form';

  import uploaded_bar_coins_data_list_component from './segments/uploaded_bar_coins_data_list';
  import bar_coins_edit_form_component from './segments/bar_coins_edit_form';

  import uploaded_jewellery_data_list_component from './segments/uploaded_jewellery_data_list';
  import jewellery_edit_form_component from './segments/jewellery_edit_form';

  import uploaded_digital_silver_gold_data_list_component from './segments/uploaded_digital_silver_gold_data_list';
  import digital_silver_gold_edit_form_component from './segments/digital_silver_gold_edit_form';

  import uploaded_bullion_gold_bond_data_list_component from './segments/uploaded_bullion_gold_bond_data_list';
  import bullion_gold_bond_edit_form_component from './segments/bullion_gold_bond_edit_form';

  import uploaded_etf_data_list_component from './segments/uploaded_etf_data_list';
  import etf_edit_form_component from './segments/etf_edit_form';

  import uploaded_equity_bond_data_list_component from './segments/uploaded_equity_bond_data_list';
  import equity_bond_edit_form_component from './segments/equity_bond_edit_form';

  import auto_sync_dialog_first from './segments/sync-auto-statement/auto-sync-dialog-first';
  import auto_sync_dialog_two from './segments/sync-auto-statement/auto-sync-dialog-two';
  import auto_sync_dialog_three from './segments/sync-auto-statement/auto-sync-dialog-three';
  import auto_sync_dialog_fourth from './segments/sync-auto-statement/auto-sync-dialog-fourth';



  
  import { GET_SUB_CATEGORY_DATA } from "../../store/actions.type";
  import {isUndefined } from 'lodash';
  import axios from "axios";
  import { Auth } from "aws-amplify";
 
  export default {
    components: {
      auto_sync_dialog_first,
      auto_sync_dialog_two,
      auto_sync_dialog_three,
      auto_sync_dialog_fourth,
      uploaded_equity_bond_data_list_component,
      equity_bond_edit_form_component,
      uploaded_etf_data_list_component,
      etf_edit_form_component,
      uploaded_jewellery_data_list_component,
      jewellery_edit_form_component,
      uploaded_equity_data_list_component,
      equity_edit_form_component,
      uploaded_sip_data_list_component,
      sip_investment_edit_form_component,
      uploaded_lumpsum_data_list_component,
      lumpsum_investment_edit_form_component,
      uploaded_saving_data_list_component,
      saving_edit_form_component,
      uploaded_fixed_data_list_component,
      fixed_edit_form_component,
      uploaded_sukanya_data_list_component,
      sukanya_edit_form_component,
      uploaded_recurring_data_list_component,
      recurring_edit_form_component,
      uploaded_bar_coins_data_list_component,
      bar_coins_edit_form_component,
      uploaded_digital_silver_gold_data_list_component,
      digital_silver_gold_edit_form_component,
      bullion_gold_bond_edit_form_component,
      uploaded_bullion_gold_bond_data_list_component
    },
    data: function () {
      return {
        is_auto_sync_dialog_seventh_open:false,
        capture_auto_sync_email_id:false,
        auto_sync_dialog_first_data:'',
        auto_sync_dialog_two_data:'',
        auto_sync_dialog_fourth_data:'',
        auto_sync_dialog_three_data:'',
        is_auto_sync_dialog_first_open:false,
        is_auto_sync_dialog_two_open:false,
        is_auto_sync_dialog_three_open:false,
        is_auto_sync_dialog_fourth_open:false,
        dashboardType:'',
        previewImage:'',
        listingData:[],
        category:'',
        cross_img:'./cross.png',
        webIcon:process.env.VUE_APP_ROOT_ICONS_URL,
        fixed_deposit_count:0,
        saving_count:0,
        recurring_count:0,
        sukanya_count:0,
        subcategoryName:'',
        dialog:false,
        dialog1:false,
        csv_dialog:false,
        epf_dialog:false,
        sip_csv_dialog:false,
        preview_dialog:false,
        sip_preview_dialog:false,
        otp_uan_form_dialog:false,
        delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete-icon.png',
        manuallyId:0,
        file: '',
        editedItem:[],
        edit_dialog:false,
        exchange_items:[{id:'bse', name:'BSE'}, {id:'nse', name:'NSE'}],
        show_exchange_dropdown:false,
        show_exchange_text_field:true,
        exchange_field_type:'exchange_text_field',
        security_list:[],
        exchange:'',
        security_name:'',
        exchange_id:'',
        security_name_warning_msg:'',
        security_name_warning_msg_status:false,
        selected_exchange:'',
        selected_security_name:'',
        owner_warning_msg:'',
        selected_owner_name:'',
        owner_warning_msg_status:false,
        member_list:[],
        is_modal_open:false,
        is_sip_modal_open:false,
        uploaded_equity_list:[],
        uploaded_sip_list:[],
        equity_edit_form_data:{},
        savings_edit_form_data:{},
        sip_edit_form_data:{},
        is_equity_edit_modal_open:false,
        is_sip_edit_modal_open:false,
        equity_row_index:'',
        sip_row_index:'',
        is_fixed_deposit_edit_modal_open:false,
        lumpsum_csv_dialog:false,
        lumpsum_preview_dialog:false,
        is_lumpsum_modal_open:false,
        uploaded_lumpsum_list:[],
        lumpsum_edit_form_data:{},
        is_lumpsum_edit_modal_open:false,
        lumpsum_row_index:'',

        saving_csv_dialog:false,
        saving_preview_dialog:false,
        is_saving_modal_open:false,
        uploaded_saving_list:[],
        is_saving_edit_modal_open:false,
        saving_row_index:'',
        fixed_csv_dialog:false,
        fixed_preview_dialog:false,
        is_fixed_modal_open:false,
        uploaded_fixed_list:[],
        fixed_edit_form_data:{},
        is_fixed_edit_modal_open:false,
        
        sukanya_csv_dialog:false,
        sukanya_preview_dialog:false,
        is_sukanya_modal_open:false,
        uploaded_sukanya_list:[],
        sukanya_edit_form_data:{},
        is_sukanya_edit_modal_open:false,
        sukanya_row_index:'',
        recurring_csv_dialog:false,
        recurring_preview_dialog:false,
        is_recurring_modal_open:false,
        uploaded_recurring_list:[],
        recurring_edit_form_data:{},
        is_recurring_edit_modal_open:false,
        recurring_row_index:'',
        get_uploaded_equity_list:'',
        sub_category_name: '',

        is_fixed_deposit_modal_open:false,
        uploaded_fixed_deposit_list:[],
        fixed_deposit_edit_form_data:'',
        fixed_deposit_row_index:'',

        is_recurring_deposit_modal_open:false,
        uploaded_recurring_deposit_list:[],
        recurring_deposit_edit_form_data:'',
        recurring_deposit_row_index:'',
        is_recurring_deposit_edit_modal_open:false,

        is_sukanya_samridhi_modal_open:false,
        uploaded_sukanya_samridhi_list:[],
        sukanya_samridhi_edit_form_data:'',
        sukanya_samridhi_row_index:'',
        is_sukanya_samridhi_edit_modal_open:false,
        is_show_upload_block:true,

        is_lumpsum_investment_modal_open:false,
        uploaded_lumpsum_investment_list:[],
        lumpsum_investment_edit_form_data:'',
        lumpsum_investment_row_index:'',
        is_lumpsum_investment_edit_modal_open:false,

        is_sip_investment_modal_open:false,
        uploaded_sip_investment_list:[],
        sip_investment_edit_form_data:'',
        sip_investment_row_index:'',
        is_sip_investment_edit_modal_open:false,

        is_bar_coins_modal_open:false,
        uploaded_bar_coins_list:[],
        bar_coins_edit_form_data:'',
        bar_coins_row_index:'',
        is_bar_coins_edit_modal_open:false,

        is_jewellery_modal_open:false,
        uploaded_jewellery_list:[],
        jewellery_edit_form_data:'',
        jewellery_row_index:'',
        is_jewellery_edit_modal_open:false,

        is_digital_silver_gold_modal_open:false,
        uploaded_digital_silver_gold_list:[],
        digital_silver_gold_edit_form_data:'',
        digital_silver_gold_row_index:'',
        is_digital_silver_gold_edit_modal_open:false,

        is_bullion_gold_bond_modal_open:false,
        uploaded_bullion_gold_bond_list:[],
        bullion_gold_bond_edit_form_data:'',
        bullion_gold_bond_row_index:'',
        is_bullion_gold_bond_edit_modal_open:false,

        is_etf_modal_open:false,
        uploaded_etf_list:[],
        etf_edit_form_data:'',
        etf_row_index:'',
        is_etf_edit_modal_open:false,
        uploaded_etf_master_data_list:false,
        uploaded_etf_master_data_list:[],
        is_saving_instruction:false,
        is_fixed_instruction:false,
        is_recurring_instruction:false,
        is_sukanaya_instruction:false,

        is_lumpsump_instruction:false,
        is_sip_instruction:false,

        is_equity_instruction:false,
        is_etf_instruction:false,
        is_bond_instruction:false,
        is_bar_coins_instruction:false,
        is_jewellery_instruction:false,
        is_gold_silver_instruction:false,
        is_gold_bond_instruction:false,


        is_equity_bond_modal_open:false,
        uploaded_equity_bond_list:[],
        equity_bond_edit_form_data:'',
        equity_bond_row_index:'',
        is_equity_bond_edit_modal_open:false,
        upload_cdsl_nsdl_form_dialog:false,
        epf_uan_form_dialog:false,
        account_statement_type_itmes:[{id:'nsdl', name:'NSDL'}, {id:'cdsl', name:'CDSL'}],
        nps_account_statement_type_itmes:[{id:'kfintech', name:'Kfintech'}, {id:'protean_cra', name:'Protean CRA'}],
        account_statement_file:'',
        password:"",
        epf_uan_info_dialog:false,
        nsdl_cdsl_upload_info_dialog:false,
        family_member_list:[],
        member_list_new:[],
        family_member_new:[],
        pan_error_text : "",
        family_member_error_text : "",
        account_type_error_text : "",
        doc_error_text : "",
        nsdl_cdsl_submit_error:"",
        account_statement_type:"",
        family_member_name:"",
        epfo_member:"",
        epfo_member_error_text : "",
        accept_statement_term_condition_dialogbox:false,
        is_agree_active_error:"",
        checkboxfield:false,
        componentKey: 0,
        account_statement_text:'NSDL/CDSL',
        upload_statement_password_text:'PAN No.',
        is_read_only:'readonly',
        login_user_name:"",
        login_user_dob:"",
        uan_number:'',
        uan_error_text:'',
        epfo_submit_error:'',
        uan_last_four:'',
        uan_mobile_number:'',
        uan_txn_id:'',
        verify_otp:'',
        verify_otp_error:'',
        verify_otp_error_text:'',
        sample_url:process.env.VUE_APP_SAMPLE_UR,
        auto_sync_dialog_first:false,
        user_auto_sync_email_id:'',
        auto_sync_email_id_error:'',
        is_auto_sync_dialog_sixth_open:false,
        activating_auto_track_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'activating_auto_track.png',
        loading_gif:process.env.VUE_APP_ROOT_ICONS_URL + 'download-loading.gif',
        show_password:false,




      }
    },
    watch: {
      password(val){
          if(this.account_statement_type == 'protean_cra' || this.account_statement_type == 'kfintech'){

          }
          else{
            this.password = val.toUpperCase()
            let panStr = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(this.pancard)
            if(panStr !=true){
              
            }
          }
          
      }
      
    },  
    created (){
      this.$loading(true);

      this.auto_sync_dialog_three_data = 'mf';
      this.dashboardType = '';

      let user_name   =  this.$store.getters.getUserDetails.user_name;
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let encryptedCurrentCategoryId = this.$route.params.current_category_id;
      if(encryptedCurrentCategoryId == 1){
        this.subcategoryName = 'Deposit';
      }else if(encryptedCurrentCategoryId == 2){
        this.subcategoryName = 'Mutual';
        this.dashboardType = 'mf';

      }else if(encryptedCurrentCategoryId == 3){
        this.dashboardType = 'realestate';
        this.subcategoryName = 'Real Estate';
      }else if(encryptedCurrentCategoryId == 4){
        this.dashboardType = 'equity';
        this.subcategoryName = 'Equities & Bonds';
      }else if(encryptedCurrentCategoryId == 5){
        this.subcategoryName = 'Insurance';
      }else if(encryptedCurrentCategoryId == 6){
        this.auto_sync_dialog_three_data = 'retirement';
        this.dashboardType = 'retirement';
        this.subcategoryName = 'Retirement';
      }else if(encryptedCurrentCategoryId == 7){
        this.dashboardType = 'bullion';
        this.subcategoryName = 'Bullions';
      }else if(encryptedCurrentCategoryId == 8){
        this.subcategoryName = 'Commodities';
      }else if(encryptedCurrentCategoryId == 9){
        this.subcategoryName = 'Private Investment';
      }else
      {

      }
      if (!isUndefined(encryptedCurrentCategoryId)) localStorage.setItem('current_category_id', encryptedCurrentCategoryId);
      let decryptedCurrentCategoryId = localStorage.getItem('current_category_id');
      let storageCurrentCategoryId   = decryptedCurrentCategoryId ;
      this.$store.dispatch(GET_SUB_CATEGORY_DATA, {
        data: {
          aws_cognito_id: cognito_idp,
          subcategory_id: storageCurrentCategoryId,
          form_id: this.$route.params.id,
          user_name:this.$store.getters.getUserDetails.user_name
        },
        api: "get-subcategory-listing",
      })
      .then(() => {
        this.$loading(false);
        let category_data = this.$store.getters.getNewSubCategoryData.data;
        category_data.forEach(detail => {
          this.category = this.$store.getters.getNewSubCategoryData.data;
        });
        this.member_list = this.$store.getters.getNewSubCategoryData.member_list

        this.family_member_list = this.$store.getters.getNewSubCategoryData.member_list
        this.$store.getters.getNewSubCategoryData.member_list.forEach(member_detail => {
          if(member_detail.id == 0){
            family_member_list.push({'id':'0', 'name':member_detail.name})
          }
          else{
            family_member_list.push({'id':member_detail.id, 'name':member_detail.name})
          }
        });
      }).catch(() => {
        this.$loading(false);
      });
    },
    mounted (){
      this.$emit('preview_dialog_close', this.previewDialogClose());
      this.$emit('csv_dialog_close', this.csvDialogClose());
    },
    methods: {
      previewDialogClose(){
        this.preview_dialog = false;
      },

      csvDialogClose(){
        this.csv_dialog = false;
      },
      closeOtpDialog(){
        this.otp_uan_form_dialog=false;
      },

      setEquityBondEditFormData(data){
        this.equity_bond_edit_form_data       = data
        this.equity_bond_row_index            = data.row_index 
        this.is_equity_bond_edit_modal_open   = true
      },

      setEquityBondUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_equity_bond_list, this.equity_bond_row_index, form_array_object)
        }          
        this.is_equity_bond_edit_modal_open = false
      },


      setETFEditFormData(data){
        this.etf_edit_form_data       = data
        this.etf_row_index            = data.row_index 
        this.is_etf_edit_modal_open   = true
      },

      setETFUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_etf_list, this.etf_row_index, form_array_object)
        }          
        this.is_etf_edit_modal_open = false
      },

      setBullionGoldBondEditFormData(data){
        this.bullion_gold_bond_edit_form_data       = data
        this.bullion_gold_bond_row_index            = data.row_index 
        this.is_bullion_gold_bond_edit_modal_open   = data.is_edit_modal_open
      },

      setBullionGoldBondUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_bullion_gold_bond_list, this.bullion_gold_bond_row_index, form_array_object)
        }          
        this.is_bullion_gold_bond_edit_modal_open = false
      },

      setDigitalSilverGoldEditFormData(data){
        this.digital_silver_gold_edit_form_data       = data
        this.digital_silver_gold_row_index            = data.row_index 
        this.is_digital_silver_gold_edit_modal_open   = data.is_edit_modal_open
      },

      setDigitalSilverGoldUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_digital_silver_gold_list, this.digital_silver_gold_row_index, form_array_object)
        }          
        this.is_digital_silver_gold_edit_modal_open = false
      },

      setBarCoinsEditFormData(data){
        this.bar_coins_edit_form_data       = data
        this.bar_coins_row_index            = data.row_index 
        this.is_bar_coins_edit_modal_open   = data.is_edit_modal_open
      },

      setBarCoinsUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_bar_coins_list, this.bar_coins_row_index, form_array_object)
        }          
        this.is_bar_coins_edit_modal_open = false
      },


      setJewelleryEditFormData(data){
        this.jewellery_edit_form_data       = data
        this.jewellery_row_index            = data.row_index 
        this.is_jewellery_edit_modal_open   = data.is_edit_modal_open
      },

      setJewelleryUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_jewellery_list, this.jewellery_row_index, form_array_object)
        }          
        this.is_jewellery_edit_modal_open = false
      },

      setEquityUpdatedFormData(data){
        this.equity_edit_form_data     = data.equity_row_item_detail
        this.security_list             = data.get_security_list
        this.equity_row_index          = data.row_index 
        this.is_equity_edit_modal_open = data.is_equity_edit_modal_open
      },
      setSavingEditFormData(data){
        this.savings_edit_form_data    = data
        this.saving_row_index          = data.row_index 
        this.is_saving_edit_modal_open = data.is_savings_edit_modal_open
      },
      setFixedDepositEditFormData(data){
        this.fixed_deposit_edit_form_data     = data
        this.fixed_deposit_row_index          = data.row_index 
        this.is_fixed_deposit_edit_modal_open = data.is_edit_modal_open
      },

      setRecurringDepositEditFormData(data){
        this.recurring_deposit_edit_form_data     = data
        this.recurring_deposit_row_index          = data.row_index 
        this.is_recurring_deposit_edit_modal_open = data.is_edit_modal_open
      },

      setSukanyaSamridhiEditFormData(data){
        this.sukanya_samridhi_edit_form_data     = data
        this.sukanya_samridhi_row_index          = data.row_index 
        this.is_sukanya_samridhi_edit_modal_open = data.is_edit_modal_open
      },

      setLumpsumInvestmentEditFormData(data){
        this.lumpsum_investment_edit_form_data       = data
        this.lumpsum_investment_row_index            = data.row_index 
        this.is_lumpsum_investment_edit_modal_open   = data.is_edit_modal_open
      },


      setSipInvestmentEditFormData(data){
        this.sip_investment_edit_form_data       = data
        this.sip_investment_row_index            = data.row_index 
        this.is_sip_investment_edit_modal_open   = data.is_edit_modal_open
      },

      setEquityUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_equity_list, this.equity_row_index, form_array_object)
        }          
        this.is_equity_edit_modal_open = false
      },

      setEquityEditFormData(data){
        this.equity_edit_form_data       = data
        this.equity_row_index            = data.row_index 
        this.is_equity_edit_modal_open   = data.is_edit_modal_open
      },

      setSavingUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_saving_list, this.saving_row_index, form_array_object)
        }          
        this.is_saving_edit_modal_open = false
      },

      setFixedDepositUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_fixed_deposit_list, this.fixed_deposit_row_index, form_array_object)
        }          
        this.is_fixed_deposit_edit_modal_open = false
      },

      setRecurringDepositUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_recurring_deposit_list, this.recurring_deposit_row_index, form_array_object)
        }          
        this.is_recurring_deposit_edit_modal_open = false
      },

    
      setSukanyaSamridhiUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_sukanya_samridhi_list, this.sukanya_samridhi_row_index, form_array_object)
        }          
        this.is_sukanya_samridhi_edit_modal_open = false
      },

      setLumpsumInvestmentUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_lumpsum_investment_list, this.lumpsum_investment_row_index, form_array_object)
        }          
        this.is_lumpsum_investment_edit_modal_open = false
      },

      setSipInvestmentUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_sip_investment_list, this.sip_investment_row_index, form_array_object)
        }          
        this.is_sip_investment_edit_modal_open = false
      },

      setEquityUpdatedFormData(form_array_object){
        if(form_array_object) {
          this.$set(this.uploaded_equity_list, this.equity_row_index, form_array_object)
        }          
        this.is_equity_edit_modal_open = false
      },

      submit(e){
        if (this.file == '' || this.file ==undefined) {
          swal.fire({
            title: 'Missing File',
            text: "Please select a file.",
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          });
          return;
        }
        let route_sub_str_url = '';
        if(this.sub_category_name == 'Systematic Investment Plan'){
          route_sub_str_url = 'process-systematic-investment-plan-csv';
        } 
        else if(this.sub_category_name == 'Bars & Coins'){
          route_sub_str_url = 'process-bar-coins-csv';
        }
        else if(this.sub_category_name == 'Digital Gold/Silver'){
          route_sub_str_url = 'process-digital-silver-gold-csv';
        }
        else if(this.sub_category_name == 'Exchange Traded Funds'){
          route_sub_str_url = 'process-etf-csv';
        }
        else{
          route_sub_str_url = 'process-'+this.sub_category_name.toLowerCase().replace(' ', '-')+'-csv';
        }
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let formdata    = new FormData();
        formdata.append("aws_cognito_id", cognito_idp);
        formdata.append("doc_file", this.file);
        formdata.append("form_type", this.sub_category_name);
        formdata.append("name", this.$store.getters.getUserDetails.user_name);
        axios.post( process.env.VUE_APP_ROOT_API+route_sub_str_url,
            formdata,{
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then((response) => {
              if(response.data.status == 'error'){
                swal.fire({
                  title: response.data.message,
                  icon: 'error',
                  confirmButtonText: `Ok`
                })
              }
              else{
                if(this.sub_category_name == 'Savings Accounts'){
                  this.uploaded_saving_list   = response.data.data.list[0];
                  this.is_saving_modal_open = true
                }
                else if(this.sub_category_name == 'Fixed Deposits'){
                  this.uploaded_fixed_deposit_list   = response.data.data.list[0];
                  this.is_fixed_deposit_modal_open = true
                }
                else if(this.sub_category_name == 'Recurring Deposits'){
                  this.uploaded_recurring_deposit_list   = response.data.data.list[0];
                  this.is_recurring_deposit_modal_open = true
                }
                else if(this.sub_category_name == 'Sukanya Samriddhi'){
                  this.uploaded_sukanya_samridhi_list   = response.data.data.list[0];
                  this.is_sukanya_samridhi_modal_open = true
                }
                else if(this.sub_category_name == 'Lumpsum Investment'){
                  this.uploaded_lumpsum_investment_list   = response.data.data.list[0];
                  this.is_lumpsum_investment_modal_open = true
                }
                else if(this.sub_category_name == 'Systematic Investment Plan'){
                  this.uploaded_sip_investment_list   = response.data.data.list[0];
                  this.is_sip_investment_modal_open = true
                }
                else if(this.sub_category_name == 'Bars & Coins'){
                  this.uploaded_bar_coins_list   = response.data.data.list[0];
                  this.is_bar_coins_modal_open = true
                }
                else if(this.sub_category_name == 'Jewellery'){
                  this.uploaded_jewellery_list   = response.data.data.list[0];
                  this.is_jewellery_modal_open = true
                }
                else if(this.sub_category_name == 'Digital Gold/Silver'){
                  this.uploaded_digital_silver_gold_list   = response.data.data.list[0];
                  this.is_digital_silver_gold_modal_open = true
                }
                else if(this.sub_category_name == 'Gold Bonds'){
                  this.uploaded_bullion_gold_bond_list   = response.data.data.list[0];
                  this.is_bullion_gold_bond_modal_open = true
                }
                else if(this.sub_category_name == 'Exchange Traded Funds'){
                  this.uploaded_etf_list   = response.data.data.list[0];
                  this.is_etf_modal_open = true
                  this.uploaded_etf_master_data_list = response.data.etfs
                }
                else if(this.sub_category_name == 'Bonds'){
                  this.uploaded_equity_bond_list    = response.data.data.list[0];
                  this.is_equity_bond_modal_open    = true
                }
                else{
                  this.uploaded_equity_list   = response.data.data.list[0];
                  this.is_modal_open = true
                }
                this.is_show_upload_block = false
              }
          }).catch(() => {});
      },

      submitNsdlCdslStatement(e){
        if(this.family_member_name !='0' &&  this.family_member_name ==''){
          this.nsdl_cdsl_submit_error = '1'
          this.family_member_error_text ="Please select a valid Member!"
        }
       
        if(this.account_statement_type ==''){
          this.nsdl_cdsl_submit_error = '1'
          this.account_type_error_text ="Please select account statement type!"
        }
        
        if(this.password ==''){
          this.nsdl_cdsl_submit_error = '1'
          this.pan_error_text = "PAN No. or Password not availbale!."
        }
        else{
          this.nsdl_cdsl_submit_error = ''
        }
        if(this.account_statement_file ==''){
          this.nsdl_cdsl_submit_error = '1'
          this.doc_error_text ="Please choose File!"
        }
        if(document.getElementById('checkboxfield').checked == false){  
          this.is_agree_active_error = "Please agree to terms & conditions"
          this.nsdl_cdsl_submit_error = '1';
        }
        if(this.nsdl_cdsl_submit_error ==''){
            this.$loading(true)
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            let formdata    = new FormData();
            formdata.append("aws_cognito_id", cognito_idp);
            formdata.append("doc_file", this.account_statement_file);
            formdata.append("type", this.account_statement_type);
            formdata.append("name", this.$store.getters.getUserDetails.user_name);
            formdata.append("member_id", this.family_member_name);
            formdata.append("password", document.getElementById("password").value);
            formdata.append("user_name", this.login_user_name);
            formdata.append("user_dob", this.login_user_dob);
            //axios.post('http://127.0.0.1:8000/api/parse-encrypted-doc',
            axios.post('https://python-parse.nimeya.ai/api/parse-encrypted-doc',
            formdata,{
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Access-Control-Allow-Origin':'*'
                }
              }
            ).then((response) => {
               this.$loading(false)
              if(response.status==500){
                swal.fire({
                  title:"Invalid file or password is wrong!",
                  confirmButtonText: `Ok`
                })
                return false
              }
              else{
                let data_array = []
                response.data.data.forEach(detail => {
                   data_array.push(detail)
                })
                formdata.append("rows", JSON.stringify({"collected_data":data_array}));
                axios.post( process.env.VUE_APP_ROOT_API+'upload-account-statment',
                formdata,{
                    headers: {
                      'Content-Type': 'multipart/form-data',
                      'Access-Control-Allow-Origin':'*'
                    }
                  }
                ).then((response) => {
                  this.$loading(false)
                  if(response.data.status == 'error'){
                    swal.fire({
                      title:response.data.message ,
                      confirmButtonText: `Ok`
                    })
                    return false
                  }
                  else{
                    swal.fire({
                      title: response.data.message,
                      showCancelButton: false,
                      confirmButtonColor: `#051d42`,
                      confirmButtonText: `OK`,
                      cancelButtonColor: `#f19700`,
                    }).then(result => { 
                     
                      this.$router.push({ name: "Investometer" }).catch(() => {});
                    })  
                  }  
                }).catch((e) => {});                 
              }   
            }).catch((e) => {});
        }
      },

      submitEpfUanForm(e){
        this.epfo_submit_error = ''
        if(this.epfo_member !='0' &&  this.epfo_member ==''){
          this.epfo_submit_error = '1'
          this.epfo_member_error_text = "Please select a Member!"
        }
        
        if(this.uan_number ==''){
          this.epfo_submit_error = '1'
          this.uan_error_text = "Please Enter UAN Number!"
        }
        if(this.epfo_submit_error ==''){
            this.$loading(true);
            let formdata = new FormData();
            formdata.append("uan", this.uan_number);
            formdata.append("memberId", this.epfo_member);
            formdata.append("userId", atob(localStorage.getItem('cognito_idp')));
            axios.post( process.env.VUE_APP_ROOT_API+'v1/idfy/generate-otp',
            formdata,{
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Access-Control-Allow-Origin':'*'
                }
              }
            )
            .then((response) => {
              this.$loading(false)
              if(response.status == 422){
                this.uan_error_text = response.data.errors.uan[0]
              }
              else if(response.data.status == 'error'){
                this.uan_error_text = response.data.message
              }
              else {
                let source_output = response.data.data.result.source_output;
                if (source_output.status == 'id_not_found') {
                  this.uan_error_text = 'Invalid UAN'
                }
                else if(source_output.status == 'source_down'){
                  this.uan_error_text = 'IDFY server down. Please try after some time.'
                }
                else if(source_output.status == 'max_attempt'){
                  this.uan_error_text = 'Max attempts has been reached.'
                }
                else{
                  this.uan_last_four = source_output.mobile_number.substr(6)
                  this.uan_mobile_number = source_output.mobile_number
                  this.uan_txn_id = source_output.txn_id
                  this.otp_uan_form_dialog = true
                  swal.fire({
                    icon:'success',
                    title: "OTP Sent!",
                    showConfirmButton: false,
                    showCancelButton: false,
                    timer: 1000
                  });
                }
              }
            })
            .catch((e) => {});
        }
      },

      verifyOtp(e){
        this.verify_otp_error = ''
        if(this.verify_otp ==''){
          this.verify_otp_error = '1'
          this.verify_otp_error_text = "Please enter the verification code."
        }
        if(this.verify_otp_error ==''){
            this.$loading(true);
            let formdata = new FormData();
            formdata.append("uan", this.uan_number);
            formdata.append("mobile_number", this.uan_mobile_number);
            formdata.append("txn_id", this.uan_txn_id);
            formdata.append("otp", this.verify_otp);
            formdata.append("userId", atob(localStorage.getItem('cognito_idp')));
            formdata.append("memberId", this.epfo_member);
            axios.post( process.env.VUE_APP_ROOT_API+'v1/idfy/validate-otp',
            formdata,{
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Access-Control-Allow-Origin':'*'
                }
              }
            )
            .then((response) => {
              this.$loading(false)
              if(response.data.status == 'error'){
                swal.fire({
                  title: 'Error!',
                  text: response.data.message,
                  icon: 'error',
                  showCancelButton: false,
                  confirmButtonColor: '#051d42',
                  confirmButtonText: 'OK',
                });
              }
              else {
                let resData = response.data.data[0];
                if (resData.status == 'in_progress') {
                  this.otp_uan_form_dialog = false
                  swal.fire({
                      title: 'In Progress!',
                      text: 'Your data will be updated shortly. Please check again after sometime.',
                      icon: 'info',
                      showCancelButton: false,
                      confirmButtonColor: '#051d42',
                      confirmButtonText: 'OK',
                  })
                  .then((result) => {
                    this.$router.push({ name: "Investometer" });
                  });
                }
                else {
                  let source_output_status = resData.result.source_output.status;
                  if(source_output_status == 'source_down'){
                    swal.fire({
                      title: 'Source Down!',
                      text: 'Please try after some time.',
                      icon: 'info',
                      showCancelButton: false,
                      confirmButtonColor: '#051d42',
                      confirmButtonText: 'OK',
                    });
                  }
                  else if(source_output_status == 'otp_invalid'){
                    swal.fire({
                      title: 'Error!',
                      text: 'The otp is invalid or expired',
                      icon: 'error',
                      showCancelButton: false,
                      confirmButtonColor: '#051d42',
                      confirmButtonText: 'OK',
                    });
                  }
                  else {
                    this.otp_uan_form_dialog = false
                    swal
                    .fire({
                      html:'<img src="./22.svg"/><h1 style="color:#f19700;">Thank You</h1><br><p>The EPF details for <Mr ABC XYZZ> have been successfully updated.</p><br><p>You may go to the dashboard to view details.</p></br><p>Do you want to update EPF details for another member, then please press “Update New Member” below.</p>',
                      showCancelButton: true,
                      confirmButtonColor: "#051d42",
                      confirmButtonText: "Dashboard",
                      cancelButtonColor: "#051d42",
                      cancelButtonText: "Update New Member",
                    })
                    .then((result) => {
                      if(result.isConfirmed){
                        this.$router.push({ name: "retirement-dashboard", params: { tab:'tab-2'}});
                      }
                      else {
                        this.epfo_member = ''
                        this.uan_number = ''
                      }
                    });
                  }
                }
              }
            })
            .catch((e) => {});
        }
      },

      viewBtn(id){
         
      },
      downloadCSVBtn(id){
        if(this.sub_category_name == 'Savings Accounts'){
          window.open('https://dev-api.nimeya.ai/csv_samples/savings.csv','_blank');
        }
        else if(this.sub_category_name == 'Fixed Deposits'){
          window.open('https://dev-api.nimeya.ai/csv_samples/fixed_deposit.csv','_blank');
        }
        else if(this.sub_category_name == 'Recurring Deposits'){
          window.open('https://dev-api.nimeya.ai/csv_samples/recurring_deposits.csv','_blank');
        }
        else if(this.sub_category_name == 'Sukanya Samriddhi'){
          window.open('https://dev-api.nimeya.ai/csv_samples/sukanya_samridhi.csv','_blank');
        }
        else if(this.sub_category_name == 'Lumpsum Investment'){
          window.open('https://dev-api.nimeya.ai/csv_samples/lumpsum_investment.csv','_blank');
        }
        else if(this.sub_category_name == 'Systematic Investment Plan'){
          window.open('https://dev-api.nimeya.ai/csv_samples/sip_inestment.csv','_blank');
        }
        else if(this.sub_category_name == 'Equities'){
          window.open('https://dev-api.nimeya.ai/csv_samples/equity_share.csv','_blank');
        }
        else if(this.sub_category_name == 'Bars & Coins'){
          window.open('https://dev-api.nimeya.ai/csv_samples/bar_coins_sample.csv','_blank');
        }
        else if(this.sub_category_name == 'Jewellery'){
          window.open('https://dev-api.nimeya.ai/csv_samples/jewellery_samples.csv','_blank');
        }
        else if(this.sub_category_name == 'Equities'){
          window.open('https://dev-api.nimeya.ai/csv_samples/equity_share.csv','_blank');
        }
        else if(this.sub_category_name == 'Digital Gold/Silver'){
          window.open('https://dev-api.nimeya.ai/csv_samples/gold_silver_sample.csv','_blank');
        }
        else if(this.sub_category_name == 'Gold Bonds'){
          window.open('https://dev-api.nimeya.ai/csv_samples/bullions_gold_bond.csv','_blank');
        }
        else if(this.sub_category_name == 'Exchange Traded Funds'){
          window.open('https://dev-api.nimeya.ai/csv_samples/etf.csv','_blank');
        }
        else if(this.sub_category_name == 'Bonds'){
          window.open('https://dev-api.nimeya.ai/csv_samples/equity_bonds.csv','_blank');
        }
        else{
          window.open('https://dev-api.nimeya.ai/csv_samples/savings.csv','_blank');
        }
      },
      
      downloadSampleCSVBtn(id){
        if(this.sub_category_name == 'Savings Accounts'){
          window.open('https://dev-api.nimeya.ai/csv_samples/ssavings.csv','_blank');
        }
        else if(this.sub_category_name == 'Fixed Deposits'){
          window.open('https://dev-api.nimeya.ai/csv_samples/sfixed_deposit.csv','_blank');
        }
        else if(this.sub_category_name == 'Recurring Deposits'){
          window.open('https://dev-api.nimeya.ai/csv_samples/srecurring_deposits.csv','_blank');
        }
        else if(this.sub_category_name == 'Sukanya Samriddhi'){
          window.open('https://dev-api.nimeya.ai/csv_samples/ssukanya_samridhi.csv','_blank');
        }
        else if(this.sub_category_name == 'Lumpsum Investment'){
          window.open('https://dev-api.nimeya.ai/csv_samples/slumpsum_investment.csv','_blank');
        }
        else if(this.sub_category_name == 'Systematic Investment Plan'){
          window.open('https://dev-api.nimeya.ai/csv_samples/ssip_inestment.csv','_blank');
        }
        else if(this.sub_category_name == 'Equities'){
          window.open('https://dev-api.nimeya.ai/csv_samples/sequity_share.csv','_blank');
        }
        else if(this.sub_category_name == 'Bars & Coins'){
          window.open('https://dev-api.nimeya.ai/csv_samples/sbar_coins_sample.csv','_blank');
        }
        else if(this.sub_category_name == 'Jewellery'){
          window.open('https://dev-api.nimeya.ai/csv_samples/sjewellery_samples.csv','_blank');
        }
        else if(this.sub_category_name == 'Equities'){
          window.open('https://dev-api.nimeya.ai/csv_samples/sequity_share.csv','_blank');
        }
        else if(this.sub_category_name == 'Digital Gold/Silver'){
          window.open('https://dev-api.nimeya.ai/csv_samples/sgold_silver_sample.csv','_blank');
        }
        else if(this.sub_category_name == 'Gold Bonds'){
          window.open('https://dev-api.nimeya.ai/csv_samples/sbullions_gold_bond.csv','_blank');
        }
        else if(this.sub_category_name == 'Exchange Traded Funds'){
          window.open('https://dev-api.nimeya.ai/csv_samples/setf.csv','_blank');
        }
        else if(this.sub_category_name == 'Bonds'){
          window.open('https://dev-api.nimeya.ai/csv_samples/sequity_bonds.csv','_blank');
        }
        else{
          window.open('https://dev-api.nimeya.ai/csv_samples/ssavings.csv','_blank');
        }
      },
      manuallyBtn(id){
        if(id == 1){
          this.$router.push({ name: "SavingComponent"});
        }
        else if(id == 2){
          this.$router.push({ name: "FixedDeposit"});
        }
        else if(id == 3){
          this.$router.push({ name: "SukanyaSamriddhiYogna"});
        }
        else if(id == 4){
          this.$router.push({ name: "RecurringDeposits"});
        }
        else if(id == 31){
          this.$router.push({ name: "AddLumpsumInvestment", params: { form_id:id}});
        }
        else if(id == 32){
          this.$router.push({ name: "AddSystematicInvestmentPlan",params: { form_id:id}});
        }
        else if(id == 12){
          this.$router.push({ name: "add-equities",params: { form_id:id}});
        }
        else if(id == 25){
          this.$router.push({ name: "add-bars_and_coins",params: { form_id:id}});
        }
        else if(id == 26){
          this.$router.push({ name: "add-jwellery",params: { form_id:id}});
        }
        else if(id == 27){
          this.$router.push({ name: "add-digital-gold",params: { form_id:id}});
        }
        else if(id == 34){
          this.$router.push({ name: "add-gold-bonds",params: { form_id:id}});
        }
        else if(id == 13){
          this.$router.push({ name: "add-exchange-traded-fund",params: { form_id:id}});
        }
        else if(id == 14){
          this.$router.push({ name: "add-bonds",params: { form_id:id}});
        }
        else if(id == 22){
          this.$router.push({ name: "add-national-pension-scheme",params: { form_id:id}});
        }
         else if(id == 21){
          this.$router.push({ name: "add-employee-provident-fund",params: { form_id:id}});
        }
        else{
        }
      },
      closeCsvDialog(){
        this.is_modal_open = false;
        if(document.getElementById("fileUpload").files.length >0){
          this.$refs.file.value=null;
        }
        this.is_fixed_deposit_modal_open = false;
        this.is_saving_modal_open = false;
        this.csv_dialog = false;
        this.is_recurring_deposit_modal_open = false;
        this.is_sukanya_samridhi_modal_open = false;

        this.is_lumpsum_investment_modal_open = false;
        this.is_sip_investment_modal_open = false;
        this.is_bar_coins_modal_open = false;
        this.is_jewellery_modal_open = false;
        this.is_digital_silver_gold_modal_open = false;
        this.is_bullion_gold_bond_modal_open = false;
        this.is_etf_modal_open = false;
        this.is_equity_bond_modal_open = false;
      },
      
      uploadCSVFileBtn(id){
        this.componentKey++;
        this.file = '';
        this.csv_dialog = true
      },
      
      syncAccountBtn(){

      },
      uploadAccountBtn(){
        if(this.manuallyId == 21){
          this.epf_uan_info_dialog = true
        }
        else {
          this.nsdl_cdsl_upload_info_dialog = true
        }
      },
      handleFileUpload(e){
        this.file = document.getElementById("fileUpload").files[0]
        if(this.file.type != 'text/csv'){
          swal.fire({
            title: 'Invalid File',
            text: "Only csv file is allowed.",
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          });
          this.componentKey++;
        }
        if (this.file.type != 'text/csv' || e == null) {
          this.file = '';
        }
      },
      handleAccountStatementFileUpload(){
        this.nsdl_cdsl_submit_error = ''
        this.doc_error_text =""
        this.account_statement_file = document.getElementById("account_statement_file_upload").files[0]
      },
      editItem(item, index){
        this.editedItem   = item;
        this.edit_dialog  = true;
        this.setMasterData()
      },
      
      close(){
        this.edit_dialog  = false;
      },
      save(){
        this.listingData.push(this.editedItem)
      },
     
      backButton(){
        this.$router.push({ name: 'Investment'});
      },

      showExchange(type){
        if(type ==  'show_dropdown'){
          this.show_exchange_text_field = false
          this.show_exchange_dropdown   = true
          this.exchange_field_type      = 'exchange_dropdown_field'
        }
        else{
          this.show_exchange_text_field = true
          this.show_exchange_dropdown   = false
          this.exchange_field_type      = 'exchange_text_field'
        }
      },

      uploadCSVBtn(id){
        
        this.is_saving_instruction=false;
        this.is_fixed_instruction=false;
        this.is_recurring_instruction=false;
        this.is_sukanaya_instruction=false;
        this.is_lumpsump_instruction=false;
        this.is_sip_instruction=false;
        this.is_equity_instruction=false;
        this.is_etf_instruction=false;
        this.is_bond_instruction=false;

        this.is_bar_coins_instruction=false;
        this.is_jewellery_instruction=false;
        this.is_gold_silver_instruction=false;
        this.is_gold_bond_instruction=false;

        if(id == 1){
          this.is_saving_instruction=true;
        }
        else if(id == 2){
          this.is_fixed_instruction=true;
        }
        else if(id == 3){
          this.is_sukanaya_instruction=true;
        }
        else if(id == 4){
          this.is_recurring_instruction=true;
        }
        else if(id == 31){
          this.is_lumpsump_instruction=true;
        }
        else if(id == 32){
          this.is_sip_instruction=true;
        }
        else if(id == 12){
          this.is_equity_instruction=true;
        }
        else if(id == 13){
          this.is_etf_instruction=true;
        }
        else if(id == 14){
          this.is_bond_instruction=true;
        }

        else if(id == 25){
          this.is_bar_coins_instruction=true;
        }
        else if(id == 26){
          this.is_jewellery_instruction=true;
        }
        else if(id == 27){
          this.is_gold_silver_instruction=true;
        }
        else if(id == 34){
          this.is_gold_bond_instruction=true;
        }
        this.dialog = false;
        this.dialog1 = true;
      },

      childforms(data,id){
        this.is_show_upload_block = true;
        // console.log(id)
        if ([1,2,3,4,25,26,27].includes(id)) {
          this.is_show_upload_block = false;
        }
        if(id == 22){
          this.account_statement_text = "Kfintech/Protean CRA";
          this.upload_statement_password_text="Password"
        }
        else{
          this.account_statement_text = "NSDL/CDSL";
          this.upload_statement_password_text = 'PAN No.'
        }
        this.sub_category_name = data
        if(data == 'Sukanya Samriddhi'){
          let allow_member = this.CurrentShowAddFamilyMemberData ? this.CurrentShowAddFamilyMemberData.show_add_family_member_button : this.$store.getters.getProfileDetail.data.allow_add_family_member;
          if(allow_member == 0){
            // swal.fire({
            //   title: "Can't proceed",
            //   text: "Kindly upgrade plan to use this feature.",
            //   icon: 'warning',
            //   showCancelButton: false,
            //   confirmButtonColor: '#051d42',
            //   confirmButtonText: 'OK',
            // }).then((result) => {
            //   if (result.isConfirmed) {
                
            //   }
            // })

            this.manuallyId = id;
            this.dialog = true;


          }
          else{
            this.manuallyId = id;
            this.dialog = true;
            // this.$router.push({ name: "SukanyaSamriddhiYogna"});
          }    
        }else if(data == 'Fixed Deposits'){
            this.manuallyId = id;
            this.dialog = true;
          // this.$router.push({ name: "FixedDeposit"});
        }else if(data == 'Recurring Deposits'){
            this.manuallyId = id;
            this.dialog = true;
          // this.$router.push({ name: "RecurringDeposits"});
        }else if (id == 31) {
          this.manuallyId = id;
          this.dialog = true;
          this.dashboardType = 'mf';
          // this.$router.push({ name: "AddLumpsumInvestment", params: { form_id:id}});
        }else if (id == 32) {
          this.dashboardType = 'mf';
          this.manuallyId = id;
          this.dialog = true;
          // this.$router.push({ name: "AddSystematicInvestmentPlan",params: { form_id:id}});
        }else if (id == 12) {
          this.dashboardType = 'equity';
          this.manuallyId = id;
          this.dialog = true;
          // this.$router.push({ name: "add-equities",params: { form_id:id}});
        }else if(id == 13) {
          this.manuallyId = id;
          this.dialog = true;
          //this.$router.push({ name: "add-exchange-traded-fund",params: { form_id:id}});
        }else if(id == 14) {
          this.manuallyId = id;
          this.dialog = true;
          //this.$router.push({ name: "add-bonds",params: { form_id:id}});
        }else if (id == 25) {
          this.manuallyId = id;
          this.dialog = true;
          //this.$router.push({ name: "add-bars_and_coins",params: { form_id:id}});
        }else if (id == 26) {
          this.manuallyId = id;
          this.dialog = true;
          //this.$router.push({ name: "add-jwellery",params: { form_id:id}});
        }else if (id == 27) {
          this.manuallyId = id;
          this.dialog = true;
         // this.$router.push({ name: "add-digital-gold",params: { form_id:id}});
        }else if (id == 34) {
          this.manuallyId = id;
          this.dialog = true;
         // this.$router.push({ name: "add-gold-bonds",params: { form_id:id}});
        }else if(id == 23){
          this.$router.push({ name: "add-annuity-scheme",params: { form_id:id}});
        }else if(id == 20){
          this.$router.push({ name: "add-provident-fund",params: { form_id:id}});
        }
        else if(id == 21){
          this.manuallyId = id;
          this.epf_dialog = true;
        }
        else if(id == 22){
          this.manuallyId = id;
          this.dialog = true;
          this.dashboardType = 'retirement';

          //this.$router.push({ name: "add-national-pension-scheme",params: { form_id:id}});
        }else if(id == 24){
           this.$router.push({ name: "add-monthly-scheme",params: { form_id:id}});
        }else if(id == 15){
           this.$router.push({ name: "add-residential-real-state",params: { form_id:id}});
        }else if(id == 16){
           this.$router.push({ name: "add-commercial-real-state",params: { form_id:id}});
        }else if(id == 17){
          this.$router.push({ name: "add-industrial-real-state",params: { form_id:id}});
        }else if(id == 18){
           this.$router.push({ name: "add-land-state",params: { form_id:id}});
        }else if(id == 19){
          this.$router.push({ name: "add-real-state-investment-trust",params: { form_id:id}});
        }else if(id == 35){
          this.$router.push({ name: "add-infrastructure-investment-trust",params: { form_id:id}});
        }else if(id == 28){
          this.$router.push({ name: "add-employee-stock-opt-scheme",params: { form_id:id}});
        }else if(id == 29){
          this.$router.push({ name: "add-portfolio-mgmt-services",params: { form_id:id}});
        }else if(id == 30){
          this.$router.push({ name: "add-alternative-investment",params: { form_id:id}});
        }else if(id == 29){
          this.$router.push({ name: "add-portfolio-mgmt-services",params: { form_id:id}});
        }else if(id == 5){
          this.$router.push({ name: "add-life",params: { form_id:id}});
        }else if(id == 6){
          this.$router.push({ name: "add-health",params: { form_id:id}});
        }else if(id == 7){
          this.$router.push({ name: "add-property",params: { form_id:id}});
        }else if(id == 8){
          this.$router.push({ name: "add-vehicle",params: { form_id:id}});
        }else if(id == 9){
          this.$router.push({ name: "add-travel",params: { form_id:id}});
        }else if(id == 10){
          this.$router.push({ name: "add-group",params: { form_id:id}});
        }else if(id == 11){
          this.$router.push({ name: "add-accidental",params: { form_id:id}});
        }
        else{
          

          this.manuallyId = id;
          this.dialog = true;
          // this.$router.push({ name: "SavingComponent"});
        }
      },
      depositeDashbord(subcategoryId){
        if(subcategoryId == 1){
          this.$router.push({ name: "deposit-dashboard"});
        }else if(subcategoryId == 2){
          this.$router.push({ name: "mutual-dashboard"});
        }else if(subcategoryId == 3){
          this.$router.push({ name: "real-state-dashboard"});
        }else if(subcategoryId == 4){
          this.$router.push({ name: "equities-dashboard"});
        }else if(subcategoryId == 5){
          this.$router.push({ name: "insurance-dashboard"});
        }else if(subcategoryId == 6){
          this.$router.push({ name: "retirement-dashboard"});
        }else if(subcategoryId == 7){
          this.$router.push({ name: "bullions-dashboard"});
        }else if(subcategoryId == 8){
          this.$router.push({ name: "commodities-dashboard"});
        }else if(subcategoryId == 9){
          this.$router.push({ name: "private-dashboard"});
        }else
        {
        }
      },

      nsdlCdslUploadInfoProceed(){
        this.nsdl_cdsl_upload_info_dialog = false
      },
      CancelEpfInfoDialog(){
        this.epf_uan_info_dialog = false
      },
      proceedToNsdlCdslForm(){
        this.upload_cdsl_nsdl_form_dialog = true
      },
      proceedToEpfUanForm(){
        this.epf_uan_form_dialog = true
        let cognito_idp = atob(localStorage.getItem("cognito_idp"));
          let formdata = new FormData();
          formdata.append("aws_cognito_id", cognito_idp);
          axios
            .post(
              process.env.VUE_APP_ROOT_API + "get-family-member",
              formdata,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  "Access-Control-Allow-Origin": "*",
                },
              }
            )
            .then((response) => {
              this.member_list_new=response.data.data;
            });
      },
      trackPanNo(e){
        this.nsdl_cdsl_submit_error = ''
        this.family_member_error_text =""
        if(e == 0){
          Auth.currentAuthenticatedUser({
            bypassCache: false
          }).then(user => { 

            this.login_user_dob = user.attributes["custom:birth"]
            this.login_user_name = user.attributes["custom:name"]
            if(user.attributes["custom:pancard"] ==undefined || user.attributes["custom:pancard"] =='undefined' || user.attributes["custom:pancard"] == ''){
              this.nsdl_cdsl_submit_error = '1'
              if(this.account_statement_type == "protean_cra" || this.account_statement_type == "kfintech"){
                  this.pan_error_text = ""   
              }
              else{
                  this.pan_error_text = "PAN No. is not availbale (Please Update PAN No. from profile section than upload PDF)."
              }
            }
            else{
              this.nsdl_cdsl_submit_error = ''
              this.pan_error_text = ""

              if(this.account_statement_type == "protean_cra" || this.account_statement_type == "kfintech"){
                  this.password = ""   
              }
              else{
                  this.password = user.attributes["custom:pancard"]
                  
              }
            }
          })
        }
        else{
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let formdata    = new FormData();
          formdata.append("aws_cognito_id", cognito_idp);
          formdata.append("member_id", e);
          axios.post( process.env.VUE_APP_ROOT_API+'get-member-detail',
              formdata,{
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Access-Control-Allow-Origin':'*'
                }
              }
            ).then((response) => {   
              if(response.data.data.pan =="" || response.data.data.pan =='N/A' ){
                this.nsdl_cdsl_submit_error = '1'
                if(this.account_statement_type == "protean_cra" || this.account_statement_type == "kfintech"){
                    this.pan_error_text = ""   
                }
                else{
                    this.pan_error_text = "PAN No. is not availbale (Please Update PAN No. from profile section than upload PDF)."
                }
              }
              else{ 
                this.nsdl_cdsl_submit_error = ''
                //this.pan_error_text = ""
                this.pan_error_text = ""
                if(this.account_statement_type == "protean_cra" || this.account_statement_type == "kfintech"){
                  this.password = ""   
                }
                else{
                  this.password = response.data.data.pan
                    
                }
                
              }
            }).catch(() => {});
        }
      },

      closeAccountStatementFileUpload(){
        this.upload_cdsl_nsdl_form_dialog = false
      },

      closeEpfUanFormDialog(){
        this.epf_uan_form_dialog = false
      },

      removeError(e){
        this.nsdl_cdsl_submit_error = ''
        this.account_type_error_text =""
      },

      removeEpfoError(e){
        this.epfo_member_error_text = ''
        this.uan_error_text = ''
        this.verify_otp_error_text = ''
        this.member_list_new.forEach(member => {
          if(e == member.id) {
            this.uan_number = member.uan
            return false
          }
        });
      },

      statementUploadTermCondition(){
        this.accept_statement_term_condition_dialogbox  = true
      },

      closeAccountStatementTermCondition(){
        this.accept_statement_term_condition_dialogbox = false
      },

      agree(e){
        if(document.getElementById('checkboxfield').checked == true){  
          this.is_agree_active_error  = "Please agree to terms & conditions"
          this.nsdl_cdsl_submit_error = '1';
        }
        else{
          this.is_agree_active_error  = ""
          this.nsdl_cdsl_submit_error = '';
        }
      },

      autoTrackStatementBtn(dashboardType){
        
        this.is_auto_sync_dialog_first_open = true
      },

      openAutoSyncDialogTwo(status){
        if(status == true){
          this.is_auto_sync_dialog_two_open  = status
        }
        else{
          this.is_auto_sync_dialog_first_open  = false
        }
      },

      openAutoSyncDialogThree(status){
        if(status == true){
          this.is_auto_sync_dialog_three_open = true
        }
        else{
          this.is_auto_sync_dialog_two_open  = false
        }
      },

      openAutoSyncDialogFourth(data){
        if(data.status == true){
          this.auto_sync_dialog_fourth_data = data
          this.is_auto_sync_dialog_fourth_open = true
        }
        else{
          this.is_auto_sync_dialog_three_open  = false
        }
      },

      openAutoSyncDialogFifth(status){
        if(status == true){
          this.capture_auto_sync_email_id = true
        }
        else{
          this.is_auto_sync_dialog_fourth  = false
          this.is_auto_sync_dialog_fourth_open = false
        }
      },

      submitAutoSyncDialogFifth(){
          let is_error = false;
          (this.user_auto_sync_email_id === "")?(is_error=true, this.auto_sync_email_id_error = 'Email Id Required!'):(is_error=false, this.statement_type_error_text = '');
          
          if(!is_error ){
              this.is_auto_sync_dialog_sixth_open = true;
          }
      },


      closeDialogSixth(){
         this.is_auto_sync_dialog_sixth_open = false;
      },

      closeAutoSyncDialogCapturedEmail(){
          this.capture_auto_sync_email_id = false
          
      },

      proceedAutoTrackDialogSeventh(){
        localStorage.setItem('dashboardType', this.dashboardType);
        this.is_auto_sync_dialog_seventh_open = true
        localStorage.setItem("email_crawler_done", 'no')
        localStorage.setItem('email_crawler_link', '')

        if(localStorage.getItem('email_crawler_link') ==undefined || localStorage.getItem('email_crawler_link') !='no'){
          window.open("https://dev-api.nimeya.ai/oauth/gmail");
        } 

        
        setInterval(() => {
          if(localStorage.getItem('email_crawler_done') =='no'){
              let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
              let formdata  = new FormData();
            
              axios.get(process.env.VUE_APP_ROOT_API+"gmail/filter/"+this.auto_sync_dialog_fourth_data.statement_type+'/'+this.auto_sync_dialog_fourth_data.member_name+'/'+this.auto_sync_dialog_fourth_data.password+'/'+this.auto_sync_dialog_fourth_data.member+'/'+cognito_idp+'/'+this.user_auto_sync_email_id, formdata, )
              .then((response) => {
                if(response.data.status == 'success'){
                  localStorage.setItem("email_crawler_done", 'yes')

                  if(response.data.crawling_done_status == 'yes'){
                    localStorage.setItem("email_crawler_done", 'yes')
                    localStorage.setItem("email_crawler_link", 'no')

                    let textSegment = '';
                    if(localStorage.getItem('dashboardType') == 'retirement'){
                      this.textSegment = "NPS data updated successfully.";
                    }
                    else{
                      this.textSegment = "Equities, Mutual Funds, Bonds, REIT, InvIT investment data have been successfully updated. Please check your bashboard.";
                    }

                    swal.fire({
                      title: 'Your Auto Track has been activated successfully. Your investment details will be updated every month. This option is secure & safe. Please go to dashboard and check details. '+this.textSegment,
                      showCancelButton: false,
                      confirmButtonColor: `#051d42`,
                      confirmButtonText: `OK`,
                      cancelButtonColor: `#f19700`,
                    }).then(result => { 
                      if(localStorage.getItem('dashboardType') == 'mf'){
                        
                        this.$router.push({ name: "mutual-dashboard", params: {}}).catch(()=>{});       
                      }
                      else if(localStorage.getItem('dashboardType') == 'retirement'){
                        
                        this.$router.push({ name: "retirement-dashboard", params: {}}).catch(()=>{});       
                      }
                      else if(localStorage.getItem('dashboardType') == 'equity'){
                        
                        this.$router.push({ name: "equities-dashboard", params: {}}).catch(()=>{});       
                      }
                      else if(localStorage.getItem('dashboardType') == 'realestate'){
                        this.dashboardType = '';
                        this.$router.push({ name: "real-state-dashboard", params: {}}).catch(()=>{});       
                      }
                      else{
                        this.$router.push({ name: "Investometer", params: {}}).catch(()=>{});       
                      } 
                    })
                  }
                  else{
                    swal.fire({
                      title: response.data.message,
                      showCancelButton: false,
                      confirmButtonColor: `#051d42`,
                      confirmButtonText: `OK`,
                      cancelButtonColor: `#f19700`,
                    }).then(result => { 
                      if(localStorage.getItem('dashboardType') == 'mf'){
                        this.$router.push({ name: "mutual-dashboard", params: {}}).catch(()=>{});       
                      }
                      else if(localStorage.getItem('dashboardType') == 'retirement'){
                        this.$router.push({ name: "retirement-dashboard", params: {}}).catch(()=>{});       
                      }
                      else if(localStorage.getItem('dashboardType') == 'equity'){
                        this.$router.push({ name: "equities-dashboard", params: {}}).catch(()=>{});       
                      }
                      else if(localStorage.getItem('dashboardType') == 'realestate'){
                        this.$router.push({ name: "real-state-dashboard", params: {}}).catch(()=>{});       
                      }
                      else{
                        this.$router.push({ name: "Investometer", params: {}}).catch(()=>{});       
                      }
                    })
                  }  
                }
                else{
                  localStorage.setItem("email_crawler_done", 'no')
                  // swal.fire({
                  //   title: '',
                  //   text: "Something wrong please try aftre sometime.",
                  //   icon: 'error',
                  //   showCancelButton: false,
                  //   confirmButtonColor: '#051d42',
                  //   confirmButtonText: 'OK',
                  // });
                }
              });
          }           
        }, 10000);
        
      }
    }
  }
</script>